/*global:MessageChannel,____message_node_scope,define,JSON2*/

/*
 * MessageNode: a small api for cross-domain (where supported) message passing between windows/tabs/iframes/frames/workers. <p>
 *
 * Supports (at least) Chrome, Opera, Firefox, Safari, IE 8-11 (IE does not support cross domain message passing
 * between windows, only between iframes).
 *
 * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
 */
(function(self, universe) {

    //
    // UTILITIES
    //

    // "def" and "is" required since the type queried for instance of may not exist in the given context. The queried
    // type ("o") has to be a string argument, since JavaScript cannot call a function with a reference that resolves
    // to undefined at call-time. The function are only used where the queried type may not be defined, not for simple
    // tests like "instanceof Context" for types defines here. Be *very* careful before changing the implementation of
    // these functions, or it is likely to break in various browsers...
    function def(o, scope) {
        if (!scope) { scope = self; }
        return scope && typeof scope[o] !== "undefined";
    }
    function is(o, type, scope) {
        if (!scope) { scope = self; }

        try {
            return def(type, scope) && o instanceof scope[type];
        } catch (error) {
            return false;
        }
    }

    function obj(o) {
        return typeof o === "object";
    }
    function fn(o) {
        return typeof o === "function"; // will not catch legacy IE window or dom functions
    }
    function str(o) {
        return typeof o === "string";
    }
    function itr(o) {
        return o && typeof o.length === "number" && !str(o); // good enough for our usage!
    }
    function forward(node, args, rest) {
        var more = typeof rest !== "undefined";
        if (node.global.legacy() || more) {
            args = Array.prototype.slice.call(args);
            if (more) {
                args = args.concat(rest);
            }
        }
        return args;
    }
    function copy(source, target) { // deep!
        target = target || {};
        var name, value;
        for (name in source) {
            if (source.hasOwnProperty(name)) {
                value = source[name];
                if (obj(value)) {
                    copy(value, target[name] = {});
                } else {
                    target[name] = value;
                }
            }
        }
        return target;
    }
    function join(o, delimiter) {
        delimiter = delimiter || "";
        if (isNative(o.join) && fn(o.join)) {
            return o.join(delimiter);
        } else if (itr(o)) { // e.g. Arguments
            var i, s = "";
            for (i = 0; i < o.length; i++) {
                if (i > 0) {
                    s += delimiter;
                }
                s += o[i];
            }
            return s;
        }
        return o.toString();
    }
    function isNative(f) {
        // Cannot test for "function" type here, as old IE will give "object" for window and DOM functions...
        return f && !("prototype" in f);
    }
    function idx(o, v, offset) {
        if (isNative(o.indexOf) && fn(o.indexOf)) { // strings, Array in non-legacy browsers...
            return o.indexOf(v, offset || 0);
        } else if (itr(o)) { // arguments, Arrays in legacy browsers (never strings)...
            var i;
            for (i = offset || 0; i < o.length; i++) {
                if (o[i] === v) {
                    return i;
                }
            }
        } else if (str(o) && v) { // string in legacy browsers or where "indexOf" has been overridden...
            // We have to escape special characters: http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
            var regex = new RegExp(v.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"), "g"), match;
            if (offset) {
                regex.lastIndex = offset;
            }
            match = regex.exec(o);
            if (match) {
                return match.index;
            }
            // Fall-through
        }
        // Other types may be here, e.g. number, for which we simply return -1...
        return -1;
    }

    // Escapes "delimiter" in s where not already escaped...
    function escape(s, delimiter) {
        var i = idx(s, delimiter), j, n, offset;
        while (i !== -1) {
            j = i; n = 0;
            // Make sure the delimiter is not already escaped using a backslash...
            while (j-- && s.charAt(j) === "\\") {
                n++;
            }
            // Even number of backslashes means not escaped...
            if ((offset = n % 2) === 0) {
                s = s.substring(0, i) + "\\" + s.substring(i);
            }
            // Find next match, if any...
            i = idx(s, delimiter, i + delimiter.length + (1 - offset)); // + 1 for escaped
        }
        return s;
    }

    // Cannot use JavaScript limited split, since it will discard the reminder after "limit"
    // and we need to unescape as well...
    function unescape(s, delimiter, limit) {
        var parts = [], part, i, j, n, first = 0, last = 0, any = false, regex = new RegExp("\\\\" + delimiter, "g");
        if (!s) { return parts; }
        while (!limit || parts.length < limit - 1) {
            i = idx(s, delimiter, last);
            if (i === -1) {
                break;
            }
            j = i; n = 0;
            // Make sure the delimiter is not escaped using a backslash...
            while (j-- && s.charAt(j) === "\\") {
                n++;
            }
            // Even number of backslashes means not escaped, but remember to unescape in the
            // individual parts when needed...
            if (n % 2 === 0) {
                part = s.substring(first, i);
                if (any) {
                    part = part.replace(regex, delimiter);
                }
                parts.push(part);
                first = i + delimiter.length;
                any = false;
            } else {
                any = true;
            }
            last = i + delimiter.length;
        }
        // Remember last part, where we always have to replace since not visited here...
        parts.push(s.substring(first).replace(regex, delimiter));
        return parts;
    }

    function path(o, scope) {
        if (obj(scope)) {
            return scope;
        }
        var parts = str(scope) ? scope.split(".") : [], i = -1, a = o, b;
        try {
            while (++i < parts.length) {
                b = a[parts[i]];
                if (b == null) {
                    a[parts[i]] = b = {};
                }
                a = b;
            }
            o = a;

        } catch (e) { // SecurityError, ReferenceError, etc
            // Fall-through!
        }
        return o;
    }

    var now = Date.now || function() { return new Date().getTime(); };

    //
    // JSON
    //


    // Simple json wrapper that takes simple string message payloads into account...
    function Json(json) {
        var scope = this, parse, format;

        if (!json) { json = {}; }

        // Boolean short cut like "json: false|true" supported...
        if (typeof json !== "boolean" || json) {
            // Configured, JSON2, or JSON?
            parse = json.parse || (def("JSON2") ? (JSON2.parse || JSON2.decode) : (def("JSON") ? JSON.parse : null));
            if (!parse) {
                // jQuery or String?
                parse = def("$") ? ($.parseJSON || $.evalJSON) : (String.prototype.evalJSON ? function(o) { o.toString().evalJSON(); } : null);
            }
            // Configured, JSON2, or JSON?
            format = json.format || (def("JSON2") ? (JSON2.stringify || JSON2.encode) : (def("JSON") ? JSON.stringify : null));
            if (!format) {
                // jQuery or Object?
                format = def("$") ? $.toJSON : Object.toJSON;
            }
        }

        // Supports simple string message data structures as well as json...
        this.parse  = function(s) { return fn(parse) && scope.formatted(s) ? parse(s) : s; };
        this.format = function(o) { return !fn(format) || str(o) ? o.toString() : format(o); };

        this.formatted = function(s) { return str(s) && s.charAt(0) === "{" && s.charAt(s.length - 1) === "}"; };
        this.supported = fn(parse) && fn(format);

        this.toString = function() {
            return "Json[supported: " + scope.supported + "]";
        }
    }


    //
    // CONTEXT
    //


    // Determines the context where a given postable/listener lives: "port", "global", "worker", "window", "unknown", or "none"...
    function Context(node, context) {
        var scope = this, listeners = {}, listening = false, cachedType, legacy = null;

        // Actual context object, e.g. Window or Worker...
        this.ctx = void 0; // undefined

        // Currently, this really means IE < 10. Use to determine how event listeners are added, json support, and how
        // console behaves...
        this.legacy = function() { // TODO: <= FF6 does not support json either!
            // FIXME: ie9 issues here - does not report legacy!
            if (legacy === null) {
                legacy = false;
                try {
                    if (!fn(scope.ctx.addEventListener)) { // we need to test on Error.stack in case no ctx set, and this will do the trick
                        return legacy = true;
                    }
                } catch (e) { // SecurityError or intentional NullPointer
                    legacy = !e.stack;
                }
            }
            return legacy;
        };

        function visit(f) {
            var type, entry, i;
            for (type in listeners) {
                if (listeners.hasOwnProperty(type)) {
                    entry = listeners[type];
                    for (i = 0; i < entry.length; i++) {
                        f(type, entry[i]);
                    }
                }
            }
        }
        function add(type, listener) {
            if (!listener.added) {
                try {
                    if (scope.legacy()) {
                        scope.ctx.attachEvent("on" + type, listener.func); // legacy IE
                    } else {
                        scope.ctx.addEventListener(type, listener.func, false);
                    }
                    node.log.verbose("Added event listener: '", type, "': ", scope);
                    listener.added = listening = true;

                } catch (e) { // SecurityError
                    node.log.err("Cannot add event listener: ", scope, " -> '", type, "': ", e);
                    // Fall-though!
                }
            }
        }
        function remove(type, listener) {
            if (listener.added) {
                try {
                    if (scope.legacy()) {
                        scope.ctx.detachEvent("on" + type, listener.func); // legacy IE
                    } else {
                        scope.ctx.removeEventListener(type, listener.func);
                    }
                    node.log.verbose("Removed event listener: '", type, "': ", scope);

                } catch (e) { // e.g. a SecurityError if ctx is a remote (proxy) window...
                    node.log.err("Cannot remove event listener: ", scope, " -> '", type, "': ", e);
                    // Fall-though!
                }
            }
        }

        this.type = function() {
            if (scope.ctx) {
                if (cachedType) { return cachedType; }

                // Support "type()" for custom postables...
                var type = scope.val("type"), regex, i, s,
                    // "Object" is for cross domain windows (proxies) in Firefox - only works because we use a known sub-set of
                    // context types *and* because we support "type()" on them...
                    types = ["MessagePort", "global", "Worker", "Window", "Object"], // order and casing important!
                    keys  = ["port",        "global", "worker", "window", "window"];

                if (type) {
                    return cachedType = type;
                }

                cachedType = "unknown";

                try { s = scope.ctx.toString(); } catch (e) { // SecurityError
                    // Fall-through...
                }

                for (i = 0; i < types.length; i++) {
                    type = types[i];

                    // Non-worker environment, e.g. a Window...
                    if (node.env !== "worker") {
                        // The type may not exist at global scope at all, or if for example a parent window on a different domain,
                        // i.e. not a Window type at all, but some internal browser security proxy object...
                        if (is(scope.ctx, type, node.global.ctx)) {
                            return cachedType = keys[i];
                        }
                        // Fall-through!
                    }

                    // Worker environment, or fall-through for unknown types...
                    if (s) {
                        regex = new RegExp("\\[object [^\\[]*" + type + "[^\\]]*\\]", "i"); // e.g. workers: Chrome: [object global], IE: [object WorkerGlobalScope], Firefox: [object DedicatedWorkerGlobalScope]
                        if (regex.test(s)) {
                            return cachedType = keys[i];
                        }
                    }
                }
                return cachedType; // "unknown"
            }
            return "none";
        };

        this.val = function(path, defaultValue) {
            return Context.val(scope.ctx, path, defaultValue);
        };

        this.set = function() { return scope.type() !== "none"; };

        this.is = function(context) { // also handles undefined/null, and supports legacy IE (== instead of ===)...
            return scope.ctx == (context instanceof Context ? context.ctx : context);
        };

        // No need to update if same context, but it can be undefined...
        this.handle = function(context) {
            context = context instanceof Context ? context.ctx : context; // unwrap

            if (!scope.is(context)) {
                // Remove old listeners from old context, if any...
                scope.close();

                // Set new one...
                if (scope.ctx = context) {
                    // Apply already registered listeners, if any...
                    visit(add);
                }
                return true;
            }
            return false;
        };

        this.on = function(type, func) {
            var entry = listeners[type], listener;
            if (!entry) {
                listeners[type] = entry = [];
            }
            listener = {func: func, added: false};
            entry.push(listener); // no check for duplicates

            if (scope.ctx) {
                add(type, listener);
            }
            return scope;
        };

        this.off = function(type, func) {
            if (arguments.length) {
                var entry = listeners[type], listener, i;
                if (entry) {
                    i = entry.length;
                    while (i--) {
                        listener = entry[i];
                        if (listener.func === func) { // can be added numerous times
                            entry.splice(i, 1);
                            if (scope.ctx) {
                                remove(type, listener);
                            }
                        }
                    }
                    if (!entry.length) {
                        delete listeners[type];
                    }
                }

            // Remove all, but not not close...
            } else {
                visit(remove);
                listening = false;
                listeners = {};
            }
            return scope;
        };

        this.close = function() {
            if (listening) {
                visit(remove);
            }
            // Never delete listeners added when no actual context is set, since they are likely to be used, e.g.
            // when this function is called from "close"...
            if (scope.ctx) {
                listeners = {};
            }
            listening = false;
            legacy = null;
            cachedType = null;
            scope.ctx = void 0; // undefined
        };

        this.toString = function() {
            var s = "Context[type: " + scope.type(), ss, type, first = true;
            if (scope.legacy()) {
                s += "; legacy";
            }
            if (scope.ctx) {
                s += "; ctx: " + scope.val(null, "[???]");
                // "name" attribute?...
                ss = scope.val("name"); // no (null) default
                if (ss) {
                    s += "; name: " + ss;
                }
                // "location.pathname" attribute?
                ss = scope.val("location.pathname"); // no (null) default
                if (ss) {
                    s += "; location: '" + (ss.split(/\\|\//).pop() || "/") + "'";
                }
            }
            // Listeners...
            for (type in listeners) {
                if (listeners.hasOwnProperty(type)) {
                    if (first) {
                        first = false;
                        s += "; listeners: [";
                    } else {
                        s += ", ";
                    }
                    s += type;
                }
            }
            if (!first) {
                s += "]";
            }
            return s + "]";
        };

        // Initialise...
        scope.handle(context);
    }

    Context.val = function(ctx, path, defaultValue) {
        var parts = path ? path.split(".") : [], i = 0, value = ctx;
        try {
            while (value != null && i < parts.length) { // != intentional!
                value = value[parts[i++]];
            }
            if (fn(value)) {
                value = value(); // can raise SecurityError
            }
            if (value != null) { // != intentional!
                value = value.toString(); // can raise SecurityError
            }
        } catch (e) { // SecurityError, ReferenceError, etc
            // Fall-through!
        }
        return str(value) ? value : defaultValue;
    };


    //
    // STORE
    //

    // A simple store to keep track of created objects, e.g. nodes or networks, which is quite useful
    // for single page web applications, as well as support exposing such objects to some global
    // scoped context...
    function Store(type, ctx) {
        var scope = this, entries = {}, size = 0;

        this.get = function (name) { return entries[name]; };

        this.set = function (name, object) {
            var entry;
            if (name && object) {
                if (!entries[name]) {
                    size++;
                }
                entries[name] = entry = {object: object, log: fn(object.log) ? object.log : function() { return this; } };
            }
            return entry;
        };

        this.eksport = function(name, eksport) { // "export" reserved keyword
            // Export stored object to some scope for easy reference?
            var entry = entries[name], exported;
            if (entry) {
                // Remove old always...
                if (entry.eksport) {
                    delete entry.eksport[name];
                    delete entry.eksport;
                }
                // Add new?
                if (eksport) {
                    entry.eksport = path(ctx || self, eksport);
                    exported = "'" + (str(eksport) ? eksport + "." : "") + name + "'";
                    if (entry.eksport[name]) {
                        entry.log("Warning: object export is overriding existing property: ", exported, ": ", entry.eksport);
                    }
                    entry.eksport[name] = entry.object;
                    return exported;
                }
            }
            return null;
        };

        this.add = function (name, object, eksport) {
            var entry = entries[name];
            if (entry) {
                entry.log("Warning: overriding already created ", type, " for same global context: ", entry.object, " -> ", scope);
                if (fn(entry.object.close)) {
                    entry.object.close(); // clean-up!
                }
            }
            entry = scope.set(name, object);

            var exported = scope.eksport(name, eksport);
            if (exported) {
                entry.log("Created and exported ", type, ": ", exported, " -> ", entry.object);
            } else {
                entry.log("Created ", type, ": ", entry.object);
            }
        };

        this.remove = function (name) {
            if (entries[name]) {
                scope.eksport(name, false);
                delete entries[name];
                size--;
            }
        };

        this.toString = function() { return "Scope[type: " + type + "; size: " + size + "]"; };
    }

    //
    // ORIGINS
    //


    var FILE = "file://", LOCATION;

    // An origins map to test for allowed/disallowed node origins.
    function Origins(node, options) {

        // Creates data structure for allowed/disallowed origins for "node"...
        function createMap(tests) {
            var map = {any: false, direct: {}, regex: [], func: []}, test, i;
            if (tests) {
                if (!itr(tests)) {
                    tests = [tests];
                }
                for (i = 0; i < tests.length; i++) {
                    test = tests[i];
                    if (test) {
                        if (test instanceof RegExp) {
                            map.regex.push(test);
                        } else if (fn(test)) {
                            map.func.push(test);

                        // A direct origin test will ever only succeed if it includes a protocol, domain, and port,
                        // or file://, so we have to handle these cases explicitly...
                        } else if (str(test)) {
                            if (/^http:|^https:/i.test(test)) {
                                map.direct[Origins.origin(test)] = 1;
                                map.any = true;
                            } else if (/^file:/i.test(test)) {
                                map.direct[FILE] = 1;
                                map.any = true;
                            } else if (/^\/\//.test(test)) {
                                map.direct[Origins.origin("http:"  + test)] = 1;
                                map.direct[Origins.origin("https:" + test)] = 1;
                                map.any = true;

                            // Must be a regular expression then, since it will never ever generate a match directly...
                            } else {
                                // Ignore potential origin prefixes, such as for example www to handle redirects
                                // from www.foo.bar -> foo.bar...
                                var j, prefix, match = true;
                                while (match) {
                                    match = false;
                                    for (j = 0; j < o.ignoreOriginPrefix.length; j++) {
                                        prefix = o.ignoreOriginPrefix[j] + ".";
                                        if (idx(test, prefix) === 0) {
                                            test = test.substring(prefix.length);
                                            match = true;
                                            break; // for loop to outer, since we must re-test all again...
                                        }
                                    }
                                }

                                // Escape meta characters in the url to match (found this online somewhere, cannot remember where)...
                                test = test.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
                                // Common use-case: if the supplied value ends with an assumed domain of two or three letters, match
                                // at the end so we only allow suffixes. This will not catch domains life ".info" or what not, but
                                // then use a regular expression instead...
                                match = /\.[a-zA-Z]{2,3}(:\d+)?$/.exec(test); // :\d+ -> optional port
                                if (match) {
                                    // If no port, we have to add include an expression to match against ports, since we know we
                                    // will always be served a proper origin once we test the origins at runtime...
                                    if (!match[1]) {
                                        test += ":\\d+";
                                    }
                                    test += "$";
                                }
                                map.regex.push(new RegExp(test, "i"));
                            }

                        // This is an error, since origins are all about security...
                        } else {
                            node.err("Illegal type used for origin test: '", typeof test, "': ", test);
                        }
                    }
                }
            }
            map.any = map.any || map.regex.length || map.func.length;
            return map;
        }

        // Convenient short-cuts...
        if (itr(options.origins)) {
            options.origins = {allowed: options.origins}; // plus own origin!
        } else if (str(options.origins) || options.origins instanceof RegExp) {
            options.origins = {allowed: [options.origins]}; // ditto
        }

        var scope = this, o = options.origins || {addOwnOrigin: false};

        // Prefixes to ignore for origins to gracefully handle browser redirects like www.foo.bar -> foo.bar...
        if (str(o.ignoreOriginPrefix)) {
            o.ignoreOriginPrefix = [o.ignoreOriginPrefix];
        }
        if (!o.ignoreOriginPrefix) {
            o.ignoreOriginPrefix = ["www"];
        }
        var origins = {
            allowed:    createMap(o.allowed),
            disallowed: createMap(o.disallowed),
            parent:     o.parent, // for connecting to parent only!
            origin:     def("location", node.global.ctx) ? Origins.origin(node.global.ctx.location) : "", // this node
            secure:     false,
            callback:   null
        };

        // Special callback, since user may themselves choose what to do when ever
        // "scope.allowed(context, originOrEvent)" returns false...
        if (fn(o.callback)) {
            origins.callback = o.callback;
        } else {
            var type = str(o.callback) ? o.callback : "verbose", illegalOrigins = {};
            origins.callback = function(origin, event, node) {
                // Only log one time per origin to avoid flooding the log unless "verbose"...
                var count = illegalOrigins[origin];
                if (count) {
                    illegalOrigins[origin] = count + 1;
                    if (type != "verbose") {
                        return;
                    }
                }
                illegalOrigins[origin] = 1;
                var args = ["Origin not allowed: '", origin, "': ", node, event];
                switch (type) {
                    case "log": node.log(args); break;
                    case "err": node.log.err(args); break;
                    default:    node.log.verbose(args); break;
                }
            };
        }

        function file() { return Origins.file(origins.origin); }

        origins.secure = /^https:/i.test(origins.origin);

        // Prefix protocol agnostic parent urls with current non-file protocol - required by browsers,
        // i.e. will not simply accept //. Also, the parent origin can be any uri, but only the origin
        // is used by browsers to determine where the message should go...
        if (origins.parent !== "*") {
            // Default to same origin as parent by default, so we do not use wildcard, i.e. "*",
            // by default, only if so configured...
            if (!origins.parent) {
                origins.parent = origins.origin;

            } else {
                // Prefix protocol if not already - we assume the same protocol as this node since we
                // cannot know anything for sure...
                if (/^\/\//.test(origins.parent)) {
                    origins.parent = origins.secure ? "https:" : "http:";
                }
                origins.parent = Origins.origin(origins.parent);
            }
        }

        this.parent = function(actual) {
            if (actual && origins.parent === "*") {
                return node.parentHandler.targetOrigin(); // may still be "*"!
            }
            return origins.parent;
        };
        this.origin = function() { return origins.origin; };
        this.secure = function() { return origins.secure; };
        this.file   = file;

        // Our own origin is allowed by default if origins have been configured unless it has been configured
        // otherwise, i.e. allow all *or* if a specific origin checker has been configured that will handle
        // own origins...
        if ((typeof o.addOwnOrigin === "undefined" && origins.allowed.any) || o.addOwnOrigin) {
            origins.allowed.direct[file() ? FILE : origins.origin] = 1; // "origin" never null and already normalised if not FILE protocol!
            origins.allowed.any = true;
        }

        function allowed(context, origin) { // protocol + domain + port, "file://", "null", or empty

            function checkOrigin(map) {
                // Direct match?
                if (map.direct[origin]) {
                    return true;
                }
                // Regular expression match?
                var i;
                for (i = 0; i < map.regex.length; i++) {
                    if (map.regex[i].test(origin)) {
                        return true;
                    }
                }
                // Function match?
                for (i = 0; i < map.func.length; i++) {
                    try {
                        if (map.func[i](origin, context, node)) {
                            return true;
                        }
                    } catch (e) {
                        node.log.err("Origin test function no. ", i, " failed: '", origin, "': ", e);
                        // Fall-through!
                    }
                }
                return false;
            }

            var type = (context && context.type()) || "none";

            // Fall-safe...
            if (type === "none") {
                return false;

            // CAVEAT: the origin will only be supplied for type "window" (and "unknown"), but not for others,
            // e.g. "port". So, when using channels, the origin is not supplied as part of the event. This
            // raises a serious security issue: a "file://" node can insert itself as root of any node in the
            // tree, most importantly for the existing root (the other nodes may already have connected), and
            // thus gain access to the node tree. The existing root can declare it self to be a root node when
            // created, thus not allowing this, but the same cannot be done for other nodes in the tree
            // structure. The *only* way to prevent this is that each node in the tree declares the initial
            // parent origin *and* declares which origins it will accept messages from (as should be done
            // always!)!
            } else if (!origin) {
                return type !== "window";

            // The origin will be the string "null" for the "file://" protocol, i.e. running locally. Note that
            // the message may in theory come from a "file://" origin, while this node may be running on http,
            // for example. If both nodes are local ("file://"), we allow it, otherwise a "file://" origin must
            // be configured to be allowed/disallowed as any other domain...
            } else if (origin === "null") {
                origin = FILE; // to allow it to be matched below on fall-through...
                if (file()) {
                    return true;
                }
                // Fall-through!
            }
            // Must be specifically allowed *and* not disallowed if "origins.allowed.any" is true, otherwise just
            // not disallowed...
            return (!origins.allowed.any || checkOrigin(origins.allowed)) && !checkOrigin(origins.disallowed);
        }

        this.allowed = function(context, originOrEvent) {
            var origin, event;

            // Origin supplied as a string?
            if (str(originOrEvent)) {
                origin = originOrEvent; event = {origin: originOrEvent};

            // Event supplied, so fetch the origin from it. We enforce the origin as a string to we won't get
            // any surprises later on...
            } else {
                origin = (originOrEvent.origin || "").toString(); event = originOrEvent;
            }

            // Test *normalised* origin then, since some browsers will ignore default prot and what not...
            if (allowed(context, origin = Origins.origin(origin))) {
                return true;
            }

            // Also allow BETA origin
            if (Origins.origin(origin) === "https://beta.zmags.com:443") {
                return true;
            }

            // Notify callback, if any, of not allowed origin...
            if (origins.callback) {
                try { origins.callback(origin, event, node); } catch (e) {
                    node.log.err("Not-allowed origin callback failed: ", e);
                }
            }
            return false;
        };

        // To expose this Origins object safely, so it cannot be tampered with...
        this.proxy = function() {
            return {
                origin:   scope.origin,
                parent:   scope.parent,
                secure:   scope.secure,
                file:     scope.file,
                allowed:  scope.allowed,
                toString: scope.toString
            }
        };

        this.toString = function() {
            var s = "Origins[origin: '" + origins.origin + "'; parent: '" + origins.parent + "'; secure: " + origins.secure;
            function format(map) {
                var any = false, origin;
                s += "[";
                // Direct...
                for (origin in map.direct) {
                    if (map.direct.hasOwnProperty(origin)) {
                        if (any) {
                            s += ", ";
                        } else {
                            any = true;
                            s += "direct: [";
                        }
                        s += "'" + origin + "'";
                    }
                }
                if (any) {
                    s += "]";
                }
                // Regexes...
                if (map.regex.length) {
                    if (any) {
                        s += "; ";
                    }
                    s += "regex: [" + join(map.regex, ", ") + "]";
                    any = true;
                }
                if (map.func.length) {
                    if (any) {
                        s += "; ";
                    }
                    s += "functions: " + map.func.length;
                }
                s += "]";
            }
            if (origins.allowed.any) {
                s += "; allowed: ";
                format(origins.allowed);
            }
            if (origins.disallowed.any) {
                s += "; disallowed: ";
                format(origins.disallowed);
            }
            return s + "]";
        }
    }

    Origins.file        = function(origin) { return /^file:/i.test(origin) || origin === "null"; }; // "null" string = Firefox
    Origins.defaultPort = function(url) { return Origins.file(url) ? null : (/^http:/i.test(url) ? 80 : 443); };

    // Always returns url as-is in Workers!
    Origins.location = function(url) {
        if (url && def("document") && fn(document.createElement)) {
            if (!LOCATION) { LOCATION = document.createElement('a'); }
            LOCATION.href = url;
            var location = {
                protocol: LOCATION.protocol,
                host:     LOCATION.host,
                hostname: LOCATION.hostname,
                href:     LOCATION.href,
                port:     LOCATION.port,
                origin:   LOCATION.origin || (LOCATION.protocol + "//" + LOCATION.host), // IE, host = domain + port
                pathname: LOCATION.pathname,
                hash:     LOCATION.hash,
                search:   LOCATION.search
            }, port = location.port, i;

            // Port may be be missing if default, or never present for FILE protocol...
            if (!Origins.file(location.origin) && !port) { // zero is reserved!
                i = location.origin.length;
                location.port = port = Origins.defaultPort(location.protocol);
                location.host   += ":" + port;
                location.origin += ":" + port;
                location.href = location.origin + location.href.substring(i);
            }
            return location;
        }
        return url;
    };

    // Generate a origin that always includes protocol, and domain and port for
    // all but file://. Some browsers will ignore default port, i.e. 80 for http,
    // while others will not, and we need a common format to handle origins
    // uniformly. This is also used for locations/origins of remote nodes, so
    // we might not have access, hence the use of Context.val(..) to look up
    // individual parts...
    Origins.origin = function(location) { // string, Location, or Object (that mimics Location, see Origins.location)
        // Location may be empty here, since message events from message ports
        // will never supply any origin...
        if (location) {
            if (str(location)) { location = Origins.location(location); }

            // Firefox also uses "null" here in general (string) for origin, not only in message events...
            if (Origins.file(Context.val(location, "origin"))) {
                return FILE;
            }

            // "protocol" property may not be available in workers...
            var protocol = Context.val(location, "protocol"), port, origin;
            if (protocol) {
                // Will be null for FILE...
                port = Origins.defaultPort(protocol);
                if (port) {
                    // Same issue here: "port" may not be supplied if default...
                    return protocol + "//" + Context.val(location, "hostname") + ":" + (Context.val(location, "port") || port);
                }
                return FILE;
            }

            // Raw location, i.e. workers...
            origin = Context.val(location); // FIXME: test ports and all!
            if (origin) {
                if (Origins.file(origin)) {
                    return FILE;
                }
                origin = origin.split(/[^\/\\]\/|[^\\\/]\\/)[0];
            }
        }
        return "";
    };


    //
    // MESSAGE
    //


    // A message describes the messages posted between nodes, including type "safety". Actual message functionality
    // like formatting and parsing is delegated to the MessageFactory used. Also, to keep the Message type simple,
    // we use static methods for Method related functionality, e.g. Message.Selectors.add(message, selectors) instead
    // of message.addSelectors(selectors)...
    function Message(tag, origin, id, correlationId, sender, receiver, selectors, action, data, context, event) {
        /** {@type string} */
        this.tag = tag; // typically different ones per network if more than one network
        /** {@type string} */
        this.origin = origin; // node name, not an url origin
        /** {@type string} */
        this.id = id;
        /** {@type string} */
        this.correlationId = correlationId;
        /** {@type string} */
        this.sender = sender;
        /** {@type string} */
        this.receiver = receiver;
        /** {@type string} */
        this.selectors = selectors; // e.g. "*", "?", or "?*"
        /** {@type string} */
        this.action = action;
        /** {@type string|object} */
        this.data = data;
        /** {@type Context} */
        this.context = context; // "context" will be null for local dispatch
        /** {@type MessageEvent} */
        this.event = event || {}; // "event" will be null for local dispatch
    }

    var Actions = { // publicly exposed via a *copy* on Message.Actions, since "protocol(..)" expects these actions only
        CHILD:     "child",     // message.data: key + "json"|"string" (supported message transport), e.g. "12345;json"
        ACK:       "ack",       // message.data: encoded string as 'qualified-parent' + message factory separator + 'child origin' + key, e.g. "foo.bar.boo;http://www.goo.com;12345"
        CHILDACK:  "childAck",  // message.data: encoded string as 'qualified-parent' + message factory separator + 'child origin' + key, e.g. "foo.bar.boo;http://www.goo.com;12345"
        ORIGIN:    "origin",    // message.data: node origin
        JOIN:      "join",      // message.data: node origin, e.g. "http://www.goo.com". Message origin is the node that has joined.
        LEAVE:     "leave",     // message.data: "self"|"global"|"force"
        CLOSE:     "close",     // message.data: "self"|"global"|"force"
        COMPOSITE: "composite", // message.data: Message[], all assumed with same receivers!
        DUMP:      "dump",      // message.data: falsey
        NODES:     "nodes",     // message.data: string[] (node names)
        MESSAGE:   "message",   // message.data: user (or protocol) defined
        ANY:       "any",       // message.data: user (or protocol) defined
        ERROR:     "error",     // message.data: exception message

        protocol: function(actionOrMessage) {
            var action = Actions[((str(actionOrMessage) ? actionOrMessage : actionOrMessage.action) || Actions.MESSAGE).toUpperCase()];
            return str(action) ? action : null;
        }
    };

    var Selectors = {   // publicly exposed as Message.Selectors
        ROOT:     "@",  // invoke action on any node in path starting from root
        ALL:      "*",  // invoke action on any node in current path
        LIKE:     "~",  // invoke action on any node in path with a matching name
        FIRST:    "+",  // invoke action on any node in path until message is consumed, if ever
        REPLY:    "?",  // invoke action on any node in path, if available, with reply (from root if no match)
        QUEUE:    "^",  // enqueue always, even with indirect receivers
        NO_QUEUE: "!",  // no enqueueing what so ever, takes precedence over QUEUE

        add: function(message, selectors) {
            if (selectors) {
                if (!message.selectors) {
                    message.selectors = "";
                }
                selectors = itr(selectors) ? selectors : selectors.split(); // "string explode"
                var i;
                for (i = 0; i < selectors.length; i++) {
                    if (idx(message.selectors, selectors[i]) === -1) {
                        message.selectors += selectors[i];
                    }
                }
            }
            return message;
        },
        remove: function(message, selectors) {
            if (selectors && message.selectors) {
                selectors = itr(selectors) ? selectors : selectors.split(); // "string explode"
                var i, j, selector;
                for (i = 0; i < selectors.length; i++) {
                    selector = selectors[i];
                    j = idx(message.selectors, selector);
                    if (j !== -1) {
                        if (selector !== Selectors.LIKE) {
                            message.selectors = message.selectors.substring(0, j) + message.selectors.substring(j + selector.length);
                        } else {
                            message.selectors = message.selectors.substring(0, j); // for now, LIKE only allowed as last argument
                        }
                    }
                }
            }
            return message;
        },
        has: function(message, selectors) { // returns first matching
            if (message.selectors) {
                selectors = itr(selectors) ? selectors : selectors.split(); // "string explode"
                var i, j, selector;
                for (i = 0; i < selectors.length; i++) {
                    selector = selectors[i];
                    j = idx(message.selectors, selector);
                    if (j !== -1) {
                        if (selector !== Selectors.LIKE) {
                            return selector;
                        }
                        // Return argument for LIKE, i.e. regex to match against node names. For now, LIKE can only be
                        // the last selector, e.g. "?~foo" correct, while "~foo?" is not...
                        return message.selectors.substring(j + 1);
                    }
                }
            }
            return null;
        }
    };

    var Receivers = { // publicly exposed as a *copy* as Message.Receivers
        ROOT:     "root",
        PARENT:   "parent",
        CHILDREN: "children",
        LEAFS:    "leafs",
        SIBLINGS: "siblings",
        ALL:      "all",

        indirect: function(receiverOrMessage) {
            var receiver = Receivers[(str(receiverOrMessage) ? receiverOrMessage : receiverOrMessage.receiver).toUpperCase()];
            return str(receiver) ? receiver : null;
        },
        name: function(receiverOrMessage) {
            if (receiverOrMessage) {
                var receiver = str(receiverOrMessage) ? receiverOrMessage : receiverOrMessage.receiver, indirect = Receivers.indirect(receiver);
                return indirect ? indirect : "#" + receiver;
            }
            return null;
        }
    };


    //
    // MESSAGE FACTORY
    //


    // Delegate message factory to handle message creation, handlability, formatting, and parsing
    function MessageFactory(node, factory) {
        if (!factory) { factory = {}; }

        var limit = factory.prettyLimit || 100, sequence = 0, scope = this;

        this.delimiter = factory.delimiter || ":";

        // Supported tags, will automatically also include tags used by networks created...
        var tags = {};

        function handle(o, on) {
            if (typeof o.tag !== "undefined") {
                var objects = tags[o.tag], i;
                if (objects) {
                    i = idx(objects, o);
                    if (i === -1) {
                        if (on) {
                            objects.push(o);
                        }
                    } else if (!on) {
                        objects.splice(i, 1);
                        if (!objects.length) {
                            delete tags[o.tag];
                        }
                    }
                } else if (on) {
                    tags[o.tag] = [o];
                }
            }
            return o;
        }

        // Add node.tag by default...
        handle(node, true);

        function encode() {
            var i, encoded = [], args = itr(arguments[0]) ? arguments[0] : arguments;
            for (i = 0; i < args.length - 1; i++) {
                encoded.push(escape(args[i], scope.delimiter));
            }
            // No need to escape data in the last part...
            encoded.push(args[i]);
            return join(encoded, scope.delimiter);
        }

        function decode(s) { // "very poor man's json", all string values... :)
            var limit = arguments.length - 1, parts = unescape(s, scope.delimiter, limit);
            if (limit === 0) {
                return parts; // array as-is
            }
            var o = {}, i;
            for (i = 0; i < limit; i++) {
                o[arguments[i + 1]] = parts[i];
            }
            return o;
        }

        function closure(configured, standard) {
            return configured ? function() { return configured.apply(scope, forward(node, arguments, node)); } : standard;
        }

        function create(message, context, event) {
            var data, create = true;

            // Delegate to factory if specified, which may or may not return a Message instance...
            if (factory.create) {
                message = factory.create.call(scope, message, context, event, node);
                create = !(message instanceof Message);
            }

            // If a string, it can either be encoded where no json is supported, or stringified json...
            if (str(message)) {
                // json...
                if (scope.json.formatted(message)) {
                    message = scope.json.parse(message);

                // encoded...
                } else {
                    create = false;
                    // Limit split to 9 meaning that we never have to escape the delimiter in the actual payload data when
                    // encoding messages...
                    var m = unescape(message, scope.delimiter, 9);
                    // If we do not have the 9 parts here, the message is in a different format than we expect...
                    if (m.length === 9) {
                        message = new Message(m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], scope.json.parse(m[8]), context, event);
                    } else {
                        message = null;
                    }
                    // Fall-through...
                }
            }

            // Supplied object like {tag: .., origin: .., ..}, or even a Message, or if "message" has just been parsed from
            // a string representation into a json object, including if from the delegate factory used. "message" may be null
            // or undefined here, for example if the parsing failed above...
            if (create && message) {
                // Special case: allow data to be a function to supply the actual data, only works on posting or the factory
                // used returns such a function for "message.data"...
                if (fn(data = message.data)) {
                    data = data();
                }
                message = new Message(message.tag, message.origin, message.id, message.correlationId, message.sender, message.receiver, message.selectors, message.action, data, context || message.context, event || message.event);
            }

            // Add pretty toString and equals method...
            if (message) {
                message.toString = function() { return scope.pretty(message); };
                message.equals = function(m) { return scope.identifier(message) === scope.identifier(m); };
            }
            return message;
        }

        function id() { return ++sequence; }

        function identifier(message) {
            return message.tag + scope.delimiter + message.origin + scope.delimiter + message.id;
        }

        function format(message, transport) {
            // Just pass the string message through, regardless if legacy or not and "transport", since we then
            // simply do the parsing at the receiver side instead...
            if (str(message)) { return message; }

            if (transport !== "json") {
                // Format actual payload data. If json is not supported at all, e.g. truly legacy, the string representation
                // of "message.data" is simply used...
                return encode([message.tag, message.origin, message.id, message.correlationId, message.sender, message.receiver, message.selectors, message.action, scope.json.format(message.data || "")]);
            }
            // Format entire message as json *except* associated context and event. For composite messages, we assume they will not
            // have associated contexts/events...
            var context = message.context, event = message.event; message.context = undefined; message.event = undefined;
            try {
                return scope.json.format(message); // {tag: m[0], origin: m[1], id: m[2], correlationId: m[3], sender: m[4], receiver: m[5], selectors: m[6], action: m[7], data: m[8]};
            } finally {
                message.context = context;
                message.event = event;
            }
        }

        // The "message.sender" will always be set on "post(..)", so we do not have to validate that here...
        function validate(message) {
            function test(attribute) {
                var value = message[attribute];
                if (typeof value === "undefined" || (str(value) && !value)) {
                    node.err("Missing ", attribute, ": ", message);
                }
                return test;
            }
            test("origin")("tag")("receiver")("id");

            // Default action...
            if (!message.action) {
                message.action = Actions.MESSAGE;
            }
            return factory.validate ? factory.validate.call(scope, message, node) : message;
        }

        function handleable(message) {
            var tag, match = false;
            for (tag in tags) {
                if (tags.hasOwnProperty(tag)) {
                    if (message.tag === tag) {
                        match = true;
                        break;
                    }
                }
            }
            if (match) {
                return factory.handleable ? factory.handleable.call(scope, message, node) : true;
            }
            return false;
        }

        function pretty(message) {
            var s = message.tag + ":(" + message.origin + ":" + message.id + " -> ", data, length;
            if (message.sender && message.origin !== message.sender) {
                s += message.sender + " -> ";
            }
            if (message.selectors) {
                s += message.selectors + ":";
            }
            s += message.receiver;
            if (message.correlationId) {
                s += ":" + message.correlationId;
            }
            s += ") => {{'" + (message.action || Actions.MESSAGE);
            data = message.data;
            if (data) {
                data = scope.json.format(data);
                length = data.length;
                if (length > limit) {
                    data = data.substring(0, limit) + "..(+" + (length - limit) + " chars)";
                }
                s += "' = '" + data + "'";
            } else {
                s += "'";
            }
            return s + "}}";
        }

        // Override with supplied methods, if any, or use defaults...
        this.create     = create;
        this.validate   = validate;
        this.handle     = handle;
        this.handleable = handleable;
        this.id         = closure(factory.id, id);
        this.identifier = closure(factory.identifier, identifier);
        this.format     = closure(factory.format, format);
        this.pretty     = closure(factory.pretty, pretty);

        this.json       = new Json(factory.json); // expose for use by configured factories...
        this.encode     = encode;
        this.decode     = decode;

        this.toString = function() {
            var s = "MessageFactory[tags: [", tag, first = true;
            for (tag in tags) {
                if (tags.hasOwnProperty(tag)) {
                    if (first) {
                        first = false;
                    } else {
                        s += ", ";
                    }
                    s += tag;
                }
            }
            return s + "]; json: " + scope.json + "; delimiter: '" + scope.delimiter + "'; limit: " + limit + "]";
        };
    }


    //
    // MESSAGE DISPATCHER
    //


    // Dispatches messages: routing/posting/enqueuing
    function MessageDispatcher(node, queue, validateOnSend, noResult, actions) {

        // Per recursive "post", "received", or "dequeued" dispatching: dispatched messages are added
        // to "dispatched" on "dispatch(message, ..)" start and "count" is increased. "count" is
        // decreased on "dispatch(message, ..)" end, and if zero, ANY callback will be invoked
        // in the order dictated by "dispatched"...
        var dispatched = [], count = 0, scope = this; // TODO: consider using MessageQueue to also support async

        this.err = function(args, action) {
            var msg     = node.log.err.apply(node.log.err, args) || node.log.format(node.log.format, args), // latter if "err" logging is turned off
                entry   = dispatched[count - 1] || {},
                message = msg.message || entry.message,
                steps   = (entry.steps || newSteps(message))("error"),
                error   = msg.error || new Error(msg.text || join(args)),
                f       = (action && callback(message, action + "." + Actions.ERROR)) || callback(message, Actions.ERROR);

            if (f) {
                f(message, steps, error, msg.event);
            }
            throw error;
        };

        // Returns a function to perform a MessageNode scoped callback for the supplied (nested) action.
        function callback(message, action) {
            action = action || (message && message.action) || Actions.MESSAGE;
            var i, j, entry, target, parts = action.split("."), part, error = false, functions = [];
            // Each entry in "actions": {on: callbacks, scope: invocation scope}...
            for (i = 0; i < actions.length; i++) {
                entry = actions[i];
                // Check if there is a flag switch to test if this action is currently active or not...
                if (fn(entry.flag) && !entry.flag.apply(entry.scope, message, node)) {
                    continue;
                }
                target = entry.on;
                j = 0;
                while (target && j < parts.length) {
                    part = parts[j++];
                    target = target[part];
                    if (part === Actions.ERROR) {
                        error = true;
                    }
                }

                function push(name) {
                    var f = target[name]; // only called when "target" is known to be an object!
                    if (fn(f)) {
                        functions.push({f: f, scope: entry.scope});
                        return true;
                    }
                    return false;
                }

                // Check if specialised callback according to *origin*, not *sender* since the
                // message can very well be relayed through intermediate nodes. We also support
                // the special cases like "parent", "root", or "children" or "descendant",
                // combined...
                if (message && obj(target)) {
                    // Takes precedence: do not invoke callbacks like "parent" if we have a callback
                    // for a specific node...
                    if (!push(message.origin)) {
                        if (node.parents) {
                            // Add root specific callback?
                            if (message.origin === node.root()) {
                                push(Receivers.ROOT);
                            }
                            // Add parent specific callback?
                            if (message.origin === node.parent()) {
                                push(Receivers.PARENT);
                            }
                            // Add ancestor specific callback?
                            if (node.ancestor(message.origin)) {
                                push("ancestors");
                            }
                        }
                        if (node.children) {
                            var childHandler = node.children[message.origin];
                            if (childHandler) {
                                // Add direct child specific callback?
                                if (childHandler.is(message.origin)) {
                                    push(Receivers.CHILDREN);
                                }
                                // Add descendant specific callback?
                                push("descendants");
                            }
                        }
                    }

                } else if (fn(target)) {
                    functions.push({f: target, scope: entry.scope});
                }
            }

            return functions.length === 0 ? null : function invoker(message, steps) { // named function for better stack trace
                // args: (message, ?), e.g. error
                var i, args = forward(node, arguments), entry, result;
                for (i = 0; i < functions.length; i++) {
                    entry = functions[i];
                    // Stop processing if a function returns a defined value, but ensure that a failing
                    // callback does not prevent others from being invoked...
                    try {
                        result = entry.f.apply(entry.scope, args); // (message, steps, ?)
                        if (typeof result !== "undefined") { // also handles MessageNode.NO_RESULT!
                            break;
                        }
                    } catch (e) {
                        // Suppress errors if already notified via an error handler...
                        if (error) {
                            node.log.err("Error invocation failed: ", e);
                        } else {
                            throw e;
                        }
                    }
                }
                return result;
            }
        }

        // DISPATCH - on receive, post, and dequeue!
        function dispatch(entry) {

            // Create routing meta data describing how "entry.message" should be processed/routed regardless if posted/received...
            var routing = entry.routing = createRouting(entry);

            // Do additional processed for received messages: for messages posted at this node, we will never invoke
            // any action, so we do not need to determine if such an action must be invoked here, but routing will (may)
            // still be required...
            if (routing.type === "received") {

                // Add receive specific routing: deduce how the message should be default be processed at this node, e.g. if
                // the receiver is this node, or if an indirect receiver like PARENT is received from a descendant node...
                addReceiveRouting(routing);

                // Invoke: invoke action on this node if so deduced by pre routing/selectors...
                if (routing.invoke) {
                    routing.processed = scope.invoke(routing.message, routing.steps);
                }

                // Post selectors: deduce if the routing must continue or stop and ensure that selectors like REPLY will
                // issue replies where relevant...
                if (routing.message.selectors && !routing.self && !routing.ignore && !routing.queue) {
                    applySelectors(routing);
                }

            // Add post/dequeue specific routing...
            } else {
                addPostRouting(routing);
            }

            // Post routing: do the actual routing, if any, of the message...
            doRouting(routing);
        }


        // CREATE ROUTING - on post, receive, and dequeue!
        function createRouting(entry) {

            function relation(name) {
                return name === node.name ? "self" : (node.ancestor(name) ? "ancestor" : (node.descendant(name) ? "descendant" : "related")); // sibling or cousin, or not yet registered as specific parent/child
            }

            // Receivers can be indirect, origins and senders never...
            var message = entry.message, steps = entry.steps, indirect = Receivers.indirect(message), stepType = steps.type(),
                fromRoot = Selectors.has(message, Selectors.ROOT), queue = Selectors.has(message, Selectors.QUEUE),
                noQueue = Selectors.has(message, Selectors.NO_QUEUE), sender = relation(message.sender), from = relation(message.origin), bubble;

            // Always set bubble flag to false for direct receivers, since that will force a lookup of children first.
            // If no such child can be found, the message may still bubble up to the parent, or be enqueued locally if
            // the node in question is a root...
            if (!indirect) {
                bubble = false;

            // Keep *initial* bubble state on received for indirect receivers...
            } else if (stepType === "received") {
                bubble = fromRoot || sender !== "ancestor";

            // Set *initial* bubble state on post/dequeue for indirect receivers...
            } else {
                bubble = fromRoot                              ||
                         message.receiver === Receivers.PARENT ||
                         message.receiver === Receivers.ROOT   ||
                         message.receiver === Receivers.ALL    ||
                         message.receiver === Receivers.SIBLINGS;
            }

            // NO_QUEUE takes precedence, to allow handshake actions and the likes to be posted still...
            if (noQueue && queue) {
                Selectors.remove(message, Selectors.QUEUE);
                queue = false;
            }

            // Determine (initial) routing information that may be updated for received messages in "preRouting"...
            return {
                message:   message,
                steps:     steps,
                node:      node.type(),                            // root, node, leaf
                type:      stepType,                               // post, received, dequeued
                indirect:  indirect,                               // e.g. PARENT or undefined if direct
                bubble:    bubble,                                 // bubble bottom-up, or back top-down?
                self:      node.name === message.origin,           // message from this node?
                from:      from,                                   // where is the message sent from originally in "abstract terms", e.g. from "ancestor" or "descendant"?
                to:        indirect || relation(message.receiver), // where is the message headed in "abstract terms" or specific receiver, e.g. to "parent" or "clientX"?
                sender:    sender,                                 // where did the routed message just come from in "abstract terms"?
                relay:     from !== "self",                        // relay/routing message?
                invoke:    false,                                  // invoke action on this node?
                stop:      queue,                                  // forcefully stop routing altogether? May still stop if no more children, for example
                ignore:    false,                                  // not meant for this node at all (special case)? If true, "routing.stop" is also true.
                queue:     queue                                   // forcefully queued for now?
            };
        }


        // ADD POST ROUTING - on post/dequeue
        function addPostRouting(routing) {

            // Translate ROOT receiver into "self" when posting from root node...
            if (routing.node === "root") {
                if (routing.message.receiver === Receivers.ROOT) {
                    routing.to = "self";
                } else if (routing.message.receiver === Receivers.ALL) {
                    routing.bubble = false;
                }
                Selectors.remove(routing.message, Selectors.ROOT); // make sure we do not bubble back
            }

            // Cannot post a message to one self...
            routing.stop = routing.to === "self" || routing.queue;
         }


        // ADD RECEIVE ROUTING - on receive only
        function addReceiveRouting(routing) {

            // A direct receiver, e.g. "clientX", can both bubble or not: it will bubble if no such child is found at
            // a given node, and then be dispatched top-down from the root, or enqueued if unknown. The "bubble" flag
            // is thus initially set to false, to allow the actual routing to check the child nodes first, but the
            // message may actually bubble up if no matching child can be found at the current (non-root) node. It is
            // treated the same way regardless if received, posted, or dequeued...
            if (!routing.indirect) {
                // A special case is when multiple nodes uses the same (global/window) context, since messages posted
                // to said context will be duplicated/received as many times as there are siblings using said context.
                // Such messages has to be ignored and stopped, and no callbacks will be invoked for them...
                routing.ignore = routing.to === "related" && routing.sender === "ancestor";
                routing.stop   = routing.to === "self" || routing.ignore || routing.queue;
                routing.invoke = routing.to === "self" && routing.from !== "self" && !routing.ignore && !routing.queue;
                return;
            }

            if (routing.queue) {
                return;
            }

            var bubble = routing.bubble, stop = !Selectors.has(routing.message, Selectors.ALL);

            // A LIKE selector can for example be used in conjunction with an ALL receiver to visit all nodes
            // sharing some common name prefix...
            var match = Selectors.has(routing.message, Selectors.LIKE);
            if (match) {
                match = new RegExp(match, "i").test(node.name);
            } else {
                match = true;
            }

            // Bottom-up...
            if (routing.bubble) {

                // Invoke: invoke on matching PARENTS, or ROOT only...
                if (routing.message.receiver === Receivers.PARENT) {
                    routing.invoke = match; // never from this node since bubbling
                    routing.stop = stop; // stop unless a selector for all parents is specified

                } else if (routing.message.receiver === Receivers.ROOT) {
                    routing.invoke = routing.stop = routing.node === "root";

                // Bubble: cancel at parent for SIBLINGS, or when at root, and start traversing top-down...
                } else if (routing.message.receiver === Receivers.SIBLINGS) {
                    routing.bubble = false; // no "bubble = true" since no invoke on parent node for SIBLINGS

                } else if (routing.node === "root") {
                    routing.bubble = bubble = false;
                    Selectors.remove(routing.message, Selectors.ROOT); // make sure we do not bubble again
                }
            }

            // Top-down...
            if (!bubble) {

                // Invoke: invoke on any node for ALL, on children for SIBLINGS, or LEAFS when at leaf, except origin...
                routing.invoke = !routing.self && match;
                if (routing.message.receiver === Receivers.LEAFS) {
                    routing.invoke = routing.invoke && routing.node === "leaf";
                }

                // Stop: when at leaf; or when at children for SIBLINGS; or if no ALL selector for CHILDREN receiver, ALL
                // and LEAFS receivers cannot forcefully stop until at a leaf node; or when a composite action has been
                // invoked (no longer composite)...
                routing.stop = routing.node === "leaf" || routing.message.receiver === Receivers.SIBLINGS ||
                              (routing.message.receiver === Receivers.CHILDREN && stop) ||
                              (routing.message.action === Actions.COMPOSITE && routing.invoke);
            }
        }


        // INVOKE - only on receive!
        this.invoke = function(message, steps, action) { // public for "plugins" like MessageNodeNetwork...
            var processed, f;

            // Create steps, if not already created (needed since this function is public)...
            if (str(steps)) {
                steps = newSteps(message, steps);
            }

            node.log("Invoking action: #", message.origin, " => ", Receivers.name(message.receiver), ": ", message);

            // Can we find a corresponding action in a used target?...
            if (action || message.action) {
                f = callback(message, action);
            }
            // If no action, or no matching callback, see if we can find the default handler
            // for any such message. We do *not* default to MESSAGE action if an explicit
            // action has been supplied...
            if (!(f || action)) {
                f = callback(message, Actions.MESSAGE);
            }

            processed = {callback: f, result: null};

            // Do we have a callback for the specified action to invoke now?
            if (f) {
                steps("invoke-action");
                processed.result = f(message, steps);
            } else {
                steps("no-action");
            }

            return processed;
        };


        // APPLY SELECTORS - only on receive
        function applySelectors(routing) {
            var message = routing.message, steps = routing.steps, processed = routing.processed || {};

            // Return result to "message.origin", or from the root/leaf if we can go no further, or if we are the actual receiver...
            if (Selectors.has(message, Selectors.REPLY)) { // "?"
                if (processed.result) { // only if invoked
                    steps("reply");
                    // Post reply with the same action and a proper correlation id...
                    node.reply(message, processed.result);

                // No result or not even invoked, but we have no where else to go...
                } else if (routing.stop) {
                    steps("reply-no-result");
                    // Post reply with the same action and a proper correlation id...
                    node.reply(message, noResult);

                } else if (processed.callback) {
                    steps("not-replied");
                }
            }

            // Stop traversing when the a node in the current route consumes/processes the message successfully...
            if (Selectors.has(message, Selectors.FIRST)) { // "+"
                if (processed.callback) {
                    steps("consumed");
                    routing.stop = true;

                // No where else to try?
                } else if (routing.stop) {
                    steps("not-consumed");
                }
            }
        }


        // DO ROUTING - on post, receive, and dequeue!
        function doRouting(routing) {
            var message = routing.message, steps = routing.steps, child, childHandler, relay = node.parents, any = false;

            // Force queuing (and stop routing now)? If so, the message explicitly be dequeued to be posted eventually...
            if (routing.queue) {
                queue.enqueue(message, steps);
                return;

            // No more routing?
            } else if (routing.stop) { // will also be true if "routing.ignore" is true
                return;
            }

            // Top-down?
            if (!routing.bubble) {
                if (routing.indirect) { // indirect receiver like ALL, CHILDREN, SIBLINGS, or LEAFS
                    if (node.children) {
                        for (child in node.children) {
                            if (node.children.hasOwnProperty(child)) {
                                childHandler = node.children[child];
                                // Only post to non-shared ready child handlers that are ready - since ACK can be recursive,
                                // "message" can here have an ACK action as well!...
                                if (childHandler.is(child) && childHandler.ready(message)) {
                                    childHandler.post(message);
                                    if (!any) {
                                        steps("relay-children");
                                        any = true;
                                    }
                                }
                            }
                        }
                    }
                    if (!any) {
                        node.log("Noop message - no ", routing.indirect === Receivers.ALL ? Receivers.CHILDREN : routing.indirect, " to relay to: ", message);
                    }
                    return;

                // The receiver is an actual receiver, not a indirect one. If we have a *ready* message handler for the
                // receiver, we post to it, otherwise we relay the message to the parent, if any, *unless* one-way,
                // i.e. where the state is only "listening". Otherwise we enqueue locally at this node since then a
                // root node for the child in question. If the handler is not yet ready, i.e. handshake in progress,
                // we will also enqueue the message at the root instead (below)...
                } else {
                    childHandler = node.children && node.children[message.receiver];
                    if (childHandler) {
                        if (childHandler.ready(message)) { // can be indirect!
                            node.log("Relaying message to child: #", message.origin, " => #", message.receiver, ": ", message);
                            childHandler.post(message);
                            steps("relay-child");
                            return;
                        }
                        // If we cannot post to the child handler, the communication is one way, and we can only
                        // listen for incoming messages, never post to the child. If so, we must never relay to parent
                        // (root), since it will relay the information back to use again, so the message ends here -
                        // either queued or ignored, depending on selectors used...
                        if (relay) { // if we have parents at all
                            // This will eventually result in a "noop" step...
                            relay = childHandler.behaviour().post; // i.e. when state is just "listening"!
                        }
                    }
                    // Fall-through to enqueue/relay to parent for enqueuing!
                }
            }

            // Bottom-up - may be a fall-through for an unknown child...
            if (relay) {
                // Safe-guard: do *not* relay to parent if the message came from an ancestor, since that will likely
                // cause an infinite loop, i.e. some ancestor re-sending the message again...
                if (routing.sender !== "ancestor") {
                    node.log("Relaying message to parent: #", message.origin, " => ", Receivers.name(message.receiver), ": ", message);
                    node.parentHandler.post(message);
                    steps("relay-parent");
                } else {
                    node.err("Cannot relay message from ancestor to parent: ", message);
                }

            // Cannot enqueue messages with indirect receivers like PARENT or if the message originated at this (root) node...
            } else if (!(routing.indirect || Selectors.has(message, Selectors.NO_QUEUE))) { // "!" // FIXME: this ok to r || routing.to === "self") {
                queue.enqueue(message, steps);
            }
        }

        //

        this.dispatch = function(message, steps) { // public!
            // Create steps, if not already created...
            if (str(steps)) {
                steps = newSteps(message, steps);
            }

            var entry = {routing: null, message: message, steps: steps, ignore: false, error: null},
                validate = steps.has("received") || validateOnSend; // "post" or "dequeued"

            // Push message/steps to dispatcher queue to maintain ordering so we can ensure we invoke
            // client callbacks in correct FIFO order...
            dispatched.push(entry);
            count++;

            try {
                // By default, we only validate on receive, since we assumed messages created to be posted by this node
                // are valid...
                if (validate) {
                    // The handleable callback can for example be used to filter on message tags and actual message
                    // types, e.g. "message.event.type" values. We call it here, since may also be applicable for
                    // composite messages...
                    if (node.factory.handleable(message)) {
                        // Validate message (except sender, which is always set in "post(..)" to ensure correct behaviour). This will
                        // raise an exception if not valid. We *cannot* do this before we can handle the message, since we could
                        // then try and validate messages from arbitrary sources...
                        entry.message = node.factory.validate(message);

                    // Ignore any message we cannot handle...
                    } else {
                        entry.ignore = true;
                    }
                }

                // We do not catch and report errors here, since that is expected to be done already in
                // "dispatch", i.e. if we get an error here, it will (presumably) because "err(..)" was
                // called explicitly...
                if (!entry.ignore) {
                    // Do actual dispatch...
                    dispatch(entry);
                    // Update "ignore" flag...
                    entry.ignore = entry.routing.ignore || (entry.routing.processed && entry.routing.processed.result === noResult);
                }

                if (entry.ignore) {
                    steps("ignore"); // for stats...
                }

            } catch(e) {
                entry.error = e;
                // Add "error" step for validation/handleable errors, since dispatch errors will have set an "error" step...
                if (!steps.has("error")) {
                    scope.err(["Dispatch failed: ", message, " -> ", e], message.action);
                }
                throw e;

            } finally {
                // "message" has now been dispatched or failed, perhaps spawning recursive messages, so we are
                // ready to process ANY callback now if we are back to a zero count. On errors, we do not call
                // ANY for the failing message, but we do so for all others. On errors, the ERROR handler,
                // if any, will already have been notified for "message". For message entries where the "ignore"
                // flag has been set, we do not call ANY either...
                if (!--count) {
                    var d = dispatched, i, f;
                    dispatched = [];  // clear immediately, in case a callback fails unexpectedly...
                    count = 0;
                    for (i = 0; i < d.length; i++) {
                        entry = d[i];
                        // Add "noop" step if not other step beside "post", "received", or "dequeued" is present...
                        if (entry.steps.steps.length === 1) {
                            entry.steps("noop");
                            node.log("Noop message: ", entry.message);
                        }
                        if (!(entry.ignore || entry.error)) {
                            if (f = callback(entry.message, Actions.ANY)) {
                                f(entry.message, entry.steps, scope);
                            }
                        }
                    }
                }
            }

            // Return original steps, not those from possibly spawned dispatched messages...
            return steps;
        };

        function newSteps(message, s) {
            var stats = MessageDispatcher.stats, step = function(s) {
                if (s) {
                    // Sanity check to avoid infinite recursion and other errors...
                    if (idx(step.steps, s) !== -1) {
                        node.err("Duplicate step: '", s, "' -> ", step, ": ", message);
                    }
                    step.steps.push(s);
                    stats[s] ? stats[s]++ : stats[s] = 1;
                }
                return step;
            };
            step.steps    = [];
            step.stats    = stats; // for easy client reference
            step.has      = function(s) { return idx(step.steps, s) !== -1; };
            step.type     = function()  { return step.steps[0] }; // short-cut...
            step.toString = function()  { return "[" + join(step.steps, ", ") + "]"; };

            return s ? step(s) : step;
        }

        this.toString = function() {
            var s = "MessageDispatcher[", step, stats = MessageDispatcher.stats, first = true;
            for (step in stats) {
                if (stats.hasOwnProperty(step)) {
                    if (first) {
                        first = false;
                    } else {
                        s += ", ";
                    }
                    s += step + ": " + stats[step];
                }
            }
            return s + "]";
        };
    }

    MessageDispatcher.stats = {}; // global per environment


    //
    // MESSAGE POSTER
    //


    // Posts messages to a configured "postable" object: Window, MessagePort, Worker (or even some proxy type)...
    function MessagePoster(node, transport, origin, p/*ostable*/) {
        var scope = this, postable = new Context(node), targetOrigin = "*";

        // Transport mode: string or json...
        transport = !node.factory.json.supported || node.global.legacy() ? "string" : (transport || "json");

        this.type = postable.type;

        // The *target* origin posted to, may be updated, e.g. when a child has connected to a parent...
        this.targetOrigin = function(origin) { // getter/setter
            if (typeof origin !== "undefined") {
                // Target origin must always be "*" for FILE, or posting will be denied by the browser...
                targetOrigin = !origin || origin === "*" || Origins.file(origin) ? "*" : Origins.origin(origin);
            }
            return targetOrigin;
        };

        this.transport = function(t) {
            // We can go from json to string, but not the reverse, since the initial value is set based on
            // whether or not json is supported by the browser...
            if (typeof t !== "undefined" && transport === "json") {
                transport = t;
            }
            return transport;
        };

        this.post = function(message, transferable) { // intentionally not called "postMessage"!
            if (!postable.set()) {
                node.err("No postable set: ", scope);
            }

            // We now have a context...
            message.context = postable;

            // Arguments for postMessage differs based on "postable" type, either:
            // 1: [message] - {worker|global|port}.postMessage
            // 4: [message, [transferable]] - {worker|global}.postMessage init // port
            // 2: [message, target] - {window|unknown}.postMessage
            // 3: [message, target, [transferable]] {window|unknown}.postMessage init // port

            // First argument: always the formatted message..
            var args = [node.factory.format(message, transport)], type = scope.type();

            // Intermediate argument, if any: origin, not for workers, nor ports, but windows. We also
            // supply it in case of "unknown", i.e. we could not deduce the type, probably because the
            // browser uses some proxy object instead of the expected type, for example on cross domain
            // communication. This may not be correct, of course, but we should never get an "unknown"
            // type to begin with...
            if (type === "window" || type === "unknown") {
                args.push(targetOrigin);
            }

            // Last argument, if any: transferable, i.e. port, always last argument if supplied. Will
            // only be supplied if MessageChannel is supported, so no need to check for this here...
            if (transferable) {
                args.push([transferable]);
            }

            // Note: no logging here, since that will flood the log when relaying log messages to a
            // parent node, i.e. in a worker environment or where relaying has been configured...
            try {
                // Cannot use "apply", since "postMessage" is not always a function in IE, seems to be
                // related to using file:// protocol or cross domain...
                switch (args.length) {
                    case 1:  postable.ctx.postMessage(args[0]); break;
                    case 2:  postable.ctx.postMessage(args[0], args[1]); break;
                    default: postable.ctx.postMessage(args[0], args[1], args[2]); break;
                }

            } catch (e) { // SecurityError, not supported Error
                node.err("Cannot post message: ", node, " -> ", message, ": ", e, " => arguments: ", args);
            }
        };

        this.handle = function(p) {
            p = p instanceof Context ? p.ctx : p; // unwrap

            // No need to update if same postable, but it can be undefined...
            if (!postable.is(p)) {
                // if (p && typeof p.postMessage === "undefined") { // not a function on proxy windows in IE...
                //    node.err("Postable must declare 'postMessage' function: ", p);
                //}

                // Close old one, if any...
                scope.close();

                // Set new one...
                postable.handle(p);

                // Note: "start()" not needed if "onmessage" handler assigned like "p.onmessage = .."
                // for message ports - go figure!...
                if (postable.type() === "port") {
                    postable.ctx.start();
                }
                return true;
            }
            return false;
        };

        this.close = function() {
            var type = postable.type();
            if (type !== "none") {
                // Close postable unless it is a window, since that will close the window itself. Workers do not
                // expose a "close()" function externally, but have one internally. So, workers are not closed
                // externally, but instead when they receive a "close" action, in which case the test below will
                // succeed and the worker will thus close itself internally...
                if (type !== "window" && type !== "unknown" && fn(postable.ctx.close)) { // dare not close "unknown" since it might be a window failed to be identified
                    try {
                        postable.ctx.close();
                    } catch (e) { // SecurityError
                        node.log.err("Could not close discarded postable: ", scope, " -> ", postable, ": ", e);
                        // Fall-through!
                    }
                }
            }
            postable.close(); // can still have added listeners to remove here...
        };

        this.toString = function() {
            return "MessagePoster[target-origin: '" + targetOrigin + "'; postable: " + postable + "; transport: " + transport + "]";
        };

        // Initialise...
        if (origin) { scope.targetOrigin(origin); }
        if (p) { scope.handle(p); }
    }


    //
    // MESSAGE HANDLER
    //


    // A message handlers handles one-way (either way), or two-way communication between two fixed nodes: "node.name" and "recv" (default parent node)
    function MessageHandler(node, options, type, origins, c/*ontext*/, b/*ehaviour*/, recv) {
        var scope = this, context = new Context(node), poster = new MessagePoster(node, options.transport), behaviour = {}, targetOrigin = "*";

        this.state = "uninitialized";

        // Tree structure describing the message node tree sharing this message handler, only set for shared handlers. Sharing can be
        // for descendant sub-trees and/or for siblings sharing the same backing postable, i.e. window...
        this.shared = null;

        // The *target* origin posted to, i.e. where is the receiving node located at. Never used if this handler is only listening...
        this.targetOrigin = function(origin) { // origin of "recv"
            if (typeof origin !== "undefined") {
                // Make sure we write through to actual message poster...
                targetOrigin = poster.targetOrigin(origin);
            }
            return targetOrigin;
        };

        function actualReceiver() { return fn(recv) ? recv() : recv; } // can be undefined

        this.transport = poster.transport;
        this.behaviour = function() { return {post: behaviour.post, listen: behaviour.listen}; };

        this.ready = function(message) {
            var ready = idx(scope.state, "ready") !== -1 || (message && message.action === Actions.ACK && idx(scope.state, "waiting") !== -1); // ACK required to make this handler ready...
            if (!ready) {
                node.log.verbose("Handler not ready: ", scope, " -> message: ", message ? message : "none");
            }
            return ready;
        };

        this.bidirectional = function() {
            return behaviour.post && behaviour.listen; // may still not be ready to post!
        };

        this.post = function(message, transferable) {
            if (scope.ready(message)) {
                if (node.name === message.receiver) {
                    node.err("Cannot send message to itself: ", message);
                }
                // Tag message with sender name. Note that this changes "message"!...
                message.sender = node.name;
                node.log.verbose("Posting message: ", scope, " -> ", message);
                poster.post(message, transferable);

            } else {
                node.err("Handler cannot post: ", scope, " -> ", message);
            }
            return scope;
        };

        this.is = function(nameOrPostable) { // or Context
            return str(nameOrPostable) ? actualReceiver() === nameOrPostable : context.is(nameOrPostable);
        };

        this.qualified = function(name) {
            var qualified = {name: "#" + name, origin: targetOrigin}, parents = [], entry;
            if (!scope.is(name)) {
                // Shared descendants?
                entry = scope.shared[name];
                if (entry) {
                    if (entry.origin) {
                        qualified.origin = entry.origin;
                    }
                    while (entry && (entry.parent !== node.name)) {
                        parents.unshift(entry.parent);
                        entry = scope.shared[entry.parent];
                    }
                    qualified.name = "#" + join(parents, "(*).#") + "(*)." + qualified.name;
                }
            }
            return qualified;
        };

        // Listens for "onmessage" events!
        function handleMessage(event) {
            var start = now();
            if (!event) {
                event = node.global.event;  // IE legacy issue
            }

            // No "event.data" means not for us, or return immediately if we are closed...
            var message = event.data;
            if (!message || scope.state === "closed") {
                return; // do not log this, does not concern us...

            // Make sure we have an allowed origin, tested against the normalised *event* origin...
            } else if (!origins.allowed(context, event)) {
                return;

            // Payload probably tried marshalled as json though not supported, i.e. toString representation
            // marshalled...
            } else if (message === "[object Object]") {
                node.log.verbose("Looks like message is tried marshalled as json where not supported from: '", event.origin, "'", event);
                return;
            }

            // Try and create then...
            message = node.factory.create(message, context, event);

            // Ignore if we could not create a message...
            if (!(message instanceof Message)) {
                return;

            // Intercept incoming related log message to be logged here, since the message is not really indented
            // for this node, as to avoid flooding this node. This is a typical scenario for workers using the
            // default log implementation. If this node is also a worker node, the message is simply relayed
            // to the parent, until one is found that is not a worker (if any)...
            } else if (message.action === "log") { // TODO: for composites?!?
                node.log(message.data);
                return;

            // Ditto for relayed error messages...
            } else if (message.action === "err") {
                node.log.err(message.data);
                return;
            }

            // Message seems ok, so dispatch it...
            node.dispatcher.dispatch(message, "received");

            node.log.verbose("Processing time: ", now() - start, " ms: ", message);
        }

        this.handle = function(c, b) {
            b = b || {}; // i.e. default (post: false, listen: false)

            // Handle (new) context, implicitly closing the old one, if any. If null context, we assume the same
            // context, which is not the same as undefined, i.e. on init or clean up...
            var newContext = false, listening = behaviour.listen;
            if (c !== null) {
                newContext = context.handle(c);
            }

            // If same context and no behaviour change, we are done...
            if (!newContext && (!!b.post === !!behaviour.post && !!b.listen === !!listening)) {
                return false;
            }

            // Update behaviour, i.e. post and/or listen?
            behaviour = b;

            // Set new postable context, which will close the old one first, if any..
            if (behaviour.post) {
                if (newContext) {
                    poster.handle(context);
                    scope.state = "waiting"; // ready here, but not acknowledged...

                // If same context, it may already be ready...
                } else {
                    scope.state = idx(scope.state, "ready") !== -1 ? "ready" : "waiting";
                }

            } else if (!behaviour.listen) {
                poster.close(); // will close actual postable, which is bad if we are listening...
            }

            // Start listening for messages...
            if (behaviour.listen) {
                // Make sure we do not add the same listener for the same context multiple times...
                if (newContext || !listening) {
                    context.on("message", handleMessage);
                }
                // If we post, we will already have set the state with regards to posting above...
                scope.state = behaviour.post ? scope.state + "/listening" : "listening";

            // Remember to close old one if we were listening, but not so anymore...
            } else if (behaviour.post) {
                context.off();   // will not close actual context (postable), just remove listeners. Needed if same context is re-supplied...
            } else {
                context.close(); // close and remove...
                poster.close();  // also close actual postable...
                scope.state = "";
            }

            return true;
        };

        this.close = function() {
            if (scope.state !== "closed") {
                node.log("Closed handler: ", this);
            }
            context.close();
            poster.close();

            scope.state = "closed";
        };

        this.toString = function() {
            var s = "MessageHandler[", receiver = Receivers.name(actualReceiver()) || "";
            if (receiver) {
                s += "receiver: " + receiver + "; ";
            }
            s += "target-origin: '" + targetOrigin + "'; ";
            // $receiver is for better naming when siblings share an actual postable, e.g. window...
            s += "type: #" + node.name + (type || "").replace(/\$receiver/g, receiver) + "; state: " + scope.state;
            if (behaviour.post) {
                s += "; poster: " + poster;
            }
            if (behaviour.listen) {
                s += "; listening-context: " + context;
            }
            return s + "]";
        };

        // Initialise...
        if (c) { scope.handle(c, b); }

    }


    //
    // MESSAGE QUEUE
    //


    // A message queue is used to enqueue messages a root nodes with currently unknown receivers.
    function MessageQueue(node) {

        // (receiver -> Message[])
        var queue = {}, size = 0, scope = this;

        // Total number of queued messages for the node, regardless of receiver.
        this.size = function() { return size; };

        // Enqueues a message if so configured, or with a currently unknown receiver - the latter only called when "node" is
        // a root and with non routing receivers, e.g. no "children" receiver, but selectors like "?" are allowed!
        this.enqueue = function(message, steps) {
            var receiver = message.receiver, messages = queue[receiver], msg, i;
            if (!messages) {
                messages = [];
                queue[receiver] = messages;
            }
            // Make sure the message is not a duplicate...
            for (i = 0; i < messages.length; i++) {
                msg = messages[i];
                // Make sure we have not enqueued this message already...
                if (message.equals(msg)) {
                    node.log("Message already enqueued: #", message.origin, " => ", Receivers.name(receiver), ": ", message);
                    return;
                }
            }
            messages.push(message);
            steps("enqueue");
            size++;
            node.log.verbose("Enqueuing message: #", message.origin, " => ", Receivers.name(receiver), ": ", message);
        };

        // When a receiver becomes known to a given root, or those forcefully enqueued using a selector...
        this.dequeue = function(receiver, withSelector) {
            var messages = queue[receiver], message, selector, i;
            if (messages) {
                // We have to loop forwards to maintain order...
                for (i = 0; i < messages.length; ) {
                    message = messages[i];
                    selector = Selectors.has(message, Selectors.QUEUE) ? true : false;
                    if (typeof withSelector === "undefined" || withSelector === selector) {
                        // Remove QUEUE selector *always*, or "message" will be enqueued immediately again...
                        Selectors.remove(message, Selectors.QUEUE);
                        // Removes "message" and decreases "messages.length" by one, so "i" is still at the same index...
                        messages.splice(i, 1);
                        size--;
                        node.log.verbose("Dequeuing message: #", message.origin, " => ", Receivers.name(message.receiver), ": ", message);
                        // This may actually re-queue the message if this node was set to queue all messages before...
                        node.dispatcher.dispatch(message, "dequeued");

                    } else {
                        i++;
                    }
                }
                if (!messages.length) {
                    delete queue[receiver];
                }
            }
        };

        // When a root node is attached as a child of another node, all queued messages will be forwarded to its new (parent) root.
        this.dequeueAll = function(withSelector) {
            var receiver;
            for (receiver in queue) {
                if (queue.hasOwnProperty(receiver)) {
                    scope.dequeue(receiver, withSelector);
                }
            }
        };

        // Purges all queued messages sent by removed nodes *without* any dispatch.
        this.purge = function(remove) { // remove[name] = 1 for removal
            var receiver, sender, message, messages, i;
            // Remove queued messages with any removed child as the *origin*...
            for (receiver in queue) {
                if (queue.hasOwnProperty(receiver)) {
                    messages = queue[receiver];
                    i = messages.length;
                    while (i--) {
                        sender = messages[i].origin;
                        if (remove[sender]) {
                            message = messages.splice(i, 1)[0]; // only one removed at a time...
                            node.log.verbose("Purging queued message: ", message);
                            size--;
                        }
                    }
                    if (!messages.length) {
                        delete queue[receiver];
                    }
                }
            }
        };

        // Purges all, i.e. on (root) node close...
        this.purgeAll = function() {
            var receiver, message, messages, i;
            for (receiver in queue) {
                if (queue.hasOwnProperty(receiver)) {
                    messages = queue[receiver];
                    for (i = 0; i < messages.length; i++) {
                        message = messages[i];
                        node.log.verbose("Purging queued message: ", message);
                    }
                }
            }
            size = 0;
            queue = {};
        };

        this.toString = function() {
            var s = "MessageQueue[size: " + size, receiver, first = true;
            if (size) {
                s += "; queue: [";
                for (receiver in queue) {
                    if (queue.hasOwnProperty(receiver)) {
                        if (first) {
                            first = false;
                        } else {
                            s += ", ";
                        }
                        s += Receivers.name(receiver) + ": " + queue[receiver].length;
                    }
                }
                s += "]";
            }
            return s + "]";
        };

    }


    //
    // MESSAGE NODE CONNECTOR
    //


    // A message node connector is used to initiate the connection between parent and child nodes. It is
    // used both by parent and child nodes, i.e. handles both a child trying to connect to its parent,
    // and a parent listening for incoming children.
    function MessageNodeConnector(node, options, origins) {

        var connectOptions = options && options.connect || {},
            timeout = (node.env === "worker" ? 2 : 1) * (connectOptions.timeout || 250), // double timeout in workers, since they are truly asynchronous and likely to start quite fast...
            limit = node.global.ctx.parseInt(connectOptions.limit, 10) || (10000 / timeout), // 10 second worth of tries by default...
            listener, parentListener, timer, receiver = connectOptions.parent || Receivers.PARENT,
            key = (connectOptions.key ? (fn(connectOptions.key) ? connectOptions.key() : connectOptions.key) : now()).toString(),
            targetOrigin, transport;

        function clearTimer() {
            if (timer) {
                node.global.ctx.clearTimeout(timer);
            }
            timer = null;
        }

        function fail(msg, error) {
            if (connectOptions.err) {
                node.err(msg);
            } else if (error) {
                node.log.err(msg); // node.err already notified!
            } else {
                node.log(msg);
            }
            // Close "node.parentHandler" for proper state henceforth on the message node - this is *not*
            // the listener(s) (handler(s)) used to listen for incoming children and optionally parent messages
            // used by this connector! Also, we do not close "node.parentPoster", since that may still work, e.g.
            // relaying log messages...
            node.parentHandler.close();
        }

        // Actual connection handler from child->parent...
        function connect(count) {
            clearTimer();

            count++;

            var channel = null, message = null;

            if (limit && count >= limit) {
                // Do not raise an exception here, merely log it unless so configured...
                fail(["Could not connect to ", Receivers.name(receiver), " after ", count, " attempts with target origin: '", targetOrigin, "'"], false); // not logged as an error, since a root node will not have a parent!
                return;
            }

            // Negative counts specifies the number of timeouts to skip before trying a connect the first time, useful for
            // when a parent node is closed, i.e. give it time to reload...
            if (count >= 0) {

                // Not supported in Firefox or < IE10...
                if (options.channels) {
                    channel = new MessageChannel();

                    // Update parent handler with the specified port, since ports can only be sent *once* like this, or we get
                    // a data clone error. We therefore have to create a new channel each time we try and connect, and update
                    // the parent handler accordingly. If we are not using channels, the "node.parentContext" will already
                    // have been set once and for all...
                    node.parentHandler.handle(channel.port1, {post: true, listen: true}); // listen for "channel.port1.onmessage" events
                }

                // Signal opener/parent window that we are open for business. If "node" is in fact a root, no parent will ever
                // respond to this message, which we will handle gracefully in the specified timer. The postable supplied with
                // the message will be used by the parent to call this child node...
                try {
                    message = node.newMessage({action: Actions.CHILD, id: node.factory.id(), data: node.factory.encode(key, transport), receiver: receiver});
                    if ((count < 300 && !(count % ~~(2500 / timeout))) || (limit && count === limit - 1)) { // ~~ = bitwise OR to ensure ints, so we only log every other second to avoid flooding the log...
                        node.log("Posting connect message no. " + (count + 1) + " to ", Receivers.name(receiver), " at '" + targetOrigin + "': ", message);
                    }
                    // In legacy IE, this call is synchronous, and will cause message listeners to be fired immediately
                    // in the parent context, i.e. ACK fired before we continue here. This means that the "timer" for
                    // re-connect will not have been set yet, and it thus cannot be cleared in "connected()". Below, we
                    // thus test for "node.parents" to avoid setting the timer again if already connected...
                    node.parentPoster.post(message, channel && channel.port2);

                } catch (e) {
                    // Do not raise an exception here, merely log it unless so configured...
                    fail(["Cannot call ", Receivers.name(receiver), " with connect message: #", node.name, " -> ", message, ": ", e], true);

                    // Child nodes can still connect to "node" even if here (unless created explicitly as a leaf)...
                    return;
                }
            }

            // Try again in a bit... The test for "node.parents" is to ensure we do not fire a connect message again
            // if we already have parents. This can be the case in legacy IE where "postMessage" is synchronous, i.e.
            // it will invoke message listeners before releasing control (ACK -> connected(..))...
            if (!node.parents) {
                timer = node.global.ctx.setTimeout(function retry() { connect(count); }, timeout);
            }
        }

        // Do *not* listen for "onmessage" events here, since we will have no access to attach ourselves to the
        // parent context, e.g. remote window. Luckily, the parent attaches the handler on itself just below
        // when setting up its child listener, and as long as a single message handler is attached. That is,
        // "node.parentContext" === "node.context" on the parent node. We still have to use the handler, and
        // not just "node.parentPoster", to handle logging and (re-)load events...
        var parentRequired = !options.channels && node.parentContext.set(), same = node.global.is(node.context);
        if (parentRequired) {
            node.parentHandler.handle(node.parentContext, {post: true}); // do *not* listen for "node.parentContext.onmessage" events (security error!)
        }

        // Message handler to listen for incoming CHILD actions, which will respond with an ACK action.
        // It is *never* used for posting messages, so the supplied "node.name" as default receiver is just
        // to make the logging clearer. However, if we are not using channels, we must ensure that we have
        // at least one "onmessage" listener on "node.context", or the parent node can never communicate
        // with us - the parent cannot add it on the source window ("node.context") during connect because
        // of security constraints - same issue as for "parentContext" described above...
        if (options.type !== "leaf") { // respect *initial* type!
            listener = new MessageHandler(node, options, parentRequired && same ? "<-children<-parent" : "<-children", origins, node.context, {listen: true}); // listen for "node.context.onmessage" events
        }

        // In case the context is not the same as the global scope, i.e. a worker and not a window, we must ensure
        // we listen for events posted to the global scope, since that is how the parent will communicate with this
        // node. Workers are not transferables, unfortunately, so we have to use this form of indirection. If channels
        // are used, there is not problem since they are used directly, i.e. they are transferable. This listener is
        // never used for posting...
        if (!(options.channels || same)) {
            parentListener = new MessageHandler(node, options, "<-parent", origins, node.global, {listen: true}); // listen for "node.global.onmessage" events
        }

        // (Re-)connect to parent node...
        this.connect = function() {
            // If the node already has (a) parent(s), no need to connect again. Also, we only need to establish communication
            // to the parent node ("broker") if we have a parent context, otherwise will we simply listen for incoming child
            // request for such communication. Intermediate nodes will do both. The CHILD action posted here will be caught
            // by the "handler" defined above in the parent node connector...
            if (!node.parents && node.parentContext.set()) {
                // Make sure we now have the parent connect meta info we require...
                targetOrigin = node.parentPoster.targetOrigin();
                transport = node.parentPoster.transport();
                // Go!
                connect(node.global.legacy() ? -2 : -1); // to allow old legacy IE browsers to regain control because postMessage is synchronous...
            }
        };

        // Callback to notify this connector that a connection has been made to the parent. We cannot close the dedicated
        // listeners here, since they will still be listening for incoming children and optional parent messages depending
        // on type of contexts used...
        this.connected = function(origin, receivedKey, bidirectional) {
            // A feeble attempt to guard against pure static connect attacks, i.e. the key must at least be known before
            // we can try and connect...
            if (!origin || key !== receivedKey) {
                return false;
            }

            clearTimer();

            // Make sure no longer listening if one way...
            var listen = node.parentHandler.behaviour().listen;
            if (listen && !bidirectional) {
                node.parentHandler.handle(null/*same context*/, {post: true});
                listen = false;
            }
            // Since a parent handler, it will always post; the question is only if it listens...
            node.parentHandler.state = listen ? "ready/listening" : "ready";

            // Update (target) origins for consistency and to use actual origin instead of just "*" if
            // so initially configured; for the listeners, we will never do actual posting to these origins...
            node.parentPoster.targetOrigin(origin);
            node.parentHandler.targetOrigin(origin);

            // Parent listener, used for indirection. If one way communication, we will never listen to events from
            // the parent, so we simply close it altogether...
            if (parentListener) {
                if (listen) {
                    parentListener.targetOrigin(origin);
                } else {
                    parentListener.close(); // dedicated parent listener
                    parentListener = null;
                }
            }
            // Listen for children, so not affected if one-way with parent...
            if (listener && parentRequired && same) {
                listener.targetOrigin(origin);
            }
            return true;
        };

        this.parent = function() { return receiver; }; // node name or "parent"

        this.close = function(excludeParent) {
            clearTimer();
            if (listener) {
                listener.close(); // children and optionally parent listener
                listener = null;
            }
            if (parentListener && !excludeParent) {
                parentListener.close(); // dedicated parent listener
                parentListener = null;
            }
        };

        this.toString = function() {
            var s = "MessageNodeConnector[";
            if (listener) {
                s += "listener: " + listener;
            }
            if (parentListener) {
                if (listener) {
                    s += "; ";
                }
                s += "parent-listener: " + parentListener;
            }
            return s + "]";
        };

    }


    //
    // MESSAGE NODE
    //

    // Map of created local nodes to avoid re-creating/overriding nodes in a long lasting context, such as a
    // single page app. Closed nodes will remove themselves. Indexes by node name.
    var NODES = new Store("node");

    // A message node handles communication with its parent node, if any, and its child nodes, if any
    function MessageNode(options) { // options: name OR object

        // Implementation note: the initialization order of the properties defined below is important,
        //                      since they intricately depend on each other in numerous (unexpected) ways!...

        // JS reference to parent window/frame; undefined means root node...
        var scope = this, connector;

        // Global scoped context to attach event listeners, access console, etc...
        this.global = new Context(scope, self);
        // Node environment, *not* the type of postables used. The use of "!=" and not "!==" is intentional,
        // since legacy IE will fail the test if "!==" is used (as it should be)...
        this.env = def("window") ? (window.parent && window.parent != window ? "frame" : "window") : "worker";

        // Create default options, if none supplied...
        options = MessageNode.options(options);

        this.name = options.name;
        this.tag  = options.tag;

        // Make sure we do not use an illegal node name, i.e. one that will clash with an indirect receiver...
        if (Receivers.indirect(scope.name)) {
            throw new Error("Illegal node name: " + scope.name);
        }

        this.options = function(name) {
            var value = options, path, i = 0;
            if (name) {
                path = name.split(".");
                while (typeof value !== "undefined" && i < path.length) {
                    value = value[path[i++]];
                }
            }
            return obj(value) ? copy(value) : value;
        };

        this.children = null; // null if no children for easy testing: name -> MessageHandler
        this.parents  = null; // null if no parents: parents node names, established on successful child <-> parent handshake, i.e. CHILD->ACK->CHILDACK...

        // Create *private* map of allowed/disallowed origins so it cannot be modified externally...
        var origins = new Origins(scope, options), defaults = scope.options("defaults") || {};

        // Default receiver(s) for posted messages with no explicit receiver...
        if (str(defaults)) {
            defaults = {receiver: defaults};
        } else {
            defaults.receiver = defaults.receiver || (options.connect && options.connect.parent) || Receivers.PARENT;
        }

        // To ensure we do not expose Origins as-is, since it could then be tampered...
        this.origin  = function() { return origins.origin(); }; // will normally suffice...
        this.origins = function() { return origins.proxy(); };

        // A queue where messages with unknown receivers are enqueued at this node if and only if this node
        // has no parent, i.e. if this node is a root; if the QUEUE selector is used for a given received message,
        // or if "enqueue(true)" has been called. If this node then becomes a child of another node, i.e.
        // no longer a root, all queued messages will be dispatched to the new root node in the tree (parent or
        // some grand parent). Conversely, when a new child node registers itself to this root node, any
        // messages queued for the child will be dispatched to it...
        var queue = new MessageQueue(scope), enqueue = options.enqueue;

        // Special value to indicate no result from other nodes when selectors are used, or returned from
        // an action callback to indicate that no further callbacks should be invoked, e.g. for COMPOSITE
        // action...
        var noResult = options.noResult || MessageNode.NO_RESULT;

        //
        //
        //

        // Use channels?
        options.channels = (typeof options.channels === "undefined" || options.channels) && def("MessageChannel");

        //
        //
        //

        // Internal action dispatcher callbacks that we do not want to expose publicly for
        // parent <-> child communication ("protocol"). Note: the callbacks here do not relay
        // on json formatted data, since json may not be available, or configured not to be
        // used. That is why the factory.encode/decode functions are used explicitly...
        var on = {};

        // at parent (this): child->parent registration received
        on[Actions.CHILD] = function(message) {
            var child = message.origin, data = scope.factory.decode(message.data, "key", "transport"),
                receiver, sibling, childHandler, postable, shared, listen = true;

            // Get existing handler, if any...
            if (scope.children) {
                childHandler = scope.children[child];
                if (childHandler && childHandler.is(child)) { // TODO: what about indirect children?
                    if (!childHandler.ready()) {
                        scope.log("Child connection already in progress: #", child, ": ", scope);
                    }
                    // Remember to close the existing direct handler, if any, but do not clear the queue, if any.
                    // We have to close, since ports cannot be reused once sent, so we have to re-connect anyway...
                    childHandler.close();
                }

            // If this is the first child, including if the child was the only child and reloaded, we have to create
            // the "scope.children" map for use henceforth...
            } else {
                scope.children = {};
            }

            // Create message handler to use to communicate with the child. If the child is configured to use channels,
            // a MessagePort will be sent as part of the connect message, which we will then use, otherwise default
            // to the source (window/worker)...
            postable = message.event.ports && message.event.ports[0];
            if (!postable) {
                postable = message.event.source || message.event.target; // latter for workers
                listen = false;
            }

            // The MessageHandler.handle function implicitly called as part of the construction process will ensure
            // that the postable defined here will have a "postMessage" function, so we just need to make sure we
            // have an object here...
            if (!postable) {
                scope.err("Missing child postable: #", child, " -> ", message);
            }

            // Message ports are never shared by siblings, but a window may be. That is, sibling nodes may share the
            // same parent context (window) as a postable, and we do not want to post a message with an indirect receiver
            // to all such siblings, since they will each receive the message "the number of siblings" times then...
            if (!listen) {
                for (sibling in scope.children) {
                    if (scope.children.hasOwnProperty(sibling)) {
                        childHandler = scope.children[sibling];
                        if (childHandler.is(postable)) {
                            scope.log("Child is sharing postable with existing sibling: #", child, " -> #", sibling);
                            // The existing handler may already be shared, both by other siblings and/or for
                            // descendant nodes as well...
                            shared = childHandler.shared;
                            if (!shared) {
                                childHandler.shared = shared = {};
                            }
                            // The existing child always the first entry in the siblings array, ensuring that if it is deleted,
                            // the next in line is used as the actual receiver, so we will always have at least one child where
                            // "is(..)" will return true...
                            if (!shared.siblings) {
                                shared.siblings = [sibling];
                            }
                            shared.siblings.push(child);
                            break;
                        }
                    }
                }
            }

            // Create new message handler for the child unless shared with a sibling already using the same backing postable...
            if (!shared) {

                // "childHandler.shared" will be undefined when no longer shared, if at all. We use the reference from
                // "childHandler" to avoid keeping a reference to the local "shared" reference here...
                receiver = function() {
                    var shared = childHandler.shared;
                    return (shared && shared.siblings && shared.siblings[0]) || child;
                };

                // $receiver will be replaced with actual receiver name for better debugging...
                childHandler = new MessageHandler(scope, options, "->$receiver", origins, postable, {post: true, listen: listen}, receiver); // only listen on ports, cannot add handler to remote postable
                // Enforce that we send to the proper origin (url) of the child node...
                childHandler.targetOrigin(message.event.origin);
                // Enforce transport format of messages send to the child, so the child will be able to receive the
                // message at all. However, we can only format as json if this node supports it as well...
                childHandler.transport(data.transport); // note: siblings must use same transport!
            }

            scope.children[child] = childHandler;
            scope.log("Successful child -> parent connection: #", child, " => #", scope.name, ": ", scope, " => ", childHandler);

            // Finally reply with ACK message to it *and* all its grandchildren, done in the "ack" callback, to ensure that
            // the ancestor chain is correct - the child could be a root node! We cannot simply post to "*children" here,
            // since the message payload, i.e. the parent stack, will be different at each level in the sub-tree. Any
            // (grand-)child will response with CHILDACK (see above), causing any queued messages to be dequeued and
            // sent to this node (and possible further up)...
            scope.reply(message, scope.factory.encode(scope.parents ? join(scope.parents, ".") : "", origins.origin(), data.key), Actions.ACK);

            // We also update message data, so user defined CHILD callbacks need not decode themselves...
            message.data = data;
        };

        // at child: parent->child ack received, after CHILD message received at parent (see above)...
        on[Actions.ACK] = function(message) {
            var data = scope.factory.decode(message.data, "parents", "origin", "key"), bidirectional = true;

            // If an origin is supplied, the message is from our direct parent as part of the initial connection attempt...
            if (data.origin) {
                // Special case: if we are using channels and a origins.parent = "*" at this node, we really do not know which
                // origin the parent is from, as the origin is empty on message events sent on message ports. If we are not using
                // channels, the parent origin will already have been validated on receive, since it will be posted as part of
                // the message event. Hence, using channels is less restrictive, but what want this node to behave the same
                // regardless if we are using channels or not, so we insert a manual check for origin here for direct child
                // nodes. The check can be faked, of course, since it is based on user data, but in the general case it will
                // ensure the same behaviour channels or not. The lesson is thus: never use "*" as parent target origin if it
                // can be avoided!
                if (!origins.allowed(message.context, data.origin)) {
                    // Break connection attempt, and ensure that user-defined ACK actions will never be invoked. This mimics
                    // the behaviour had we not used channels...
                    if (origins.parent() !== "*") {
                        return noResult;
                    } else {
                        scope.log("One way communication to parent only: ", Receivers.name(scope.name), " -> ", Receivers.name(message.sender));
                        bidirectional = false;
                    }
                }

                // Notify our connector that we are now connected to a parent at "message.data.origin". If the keys does not match,
                // something is off, and we abort the connection attempt. If the message is not from our direct parent, we need
                // not concern ourselves with the connector at this point...
                if (!connector.connected(data.origin, data.key, bidirectional)) {
                    scope.log.err("Connector refused connection attempt: ", message, " -> ", scope);
                    // Break connection attempt...
                    return noResult;
                }
            }

            // Internal composite messages cannot relay on json formatting, since json may not be supported...
            scope.parents = data.parents ? data.parents.split(".") : [];
            scope.parents.push(message.sender);

            var parents = join(scope.parents, ".");
            scope.log("Successful parent ", data.bidirectional ? "->" : "<-", " child connection: #", parents, data.bidirectional ? " => #" : " <= #", scope.name, ": ", scope, " => ", scope.parentHandler);

            // Post with CHILDACK to parent, which we always know is there since "message" originated from it. Note: we cannot use "reply"
            // here, since the parent will differ, i.e. the message will bubble up through the node hierarchy, from one parent to the next...
            scope.post({action: Actions.CHILDACK, data: scope.factory.encode(parents + "." + scope.name, origins.origin(), bidirectional), receiver: Receivers.PARENT, correlationId: message.id});

            // Relay updated ancestor array to children by forwarding the slightly modified message, i.e. payload data now
            // updated with parent)...
            if (scope.children) {
                scope.post({action: Actions.ACK, data: parents, receiver: Receivers.CHILDREN, correlationId: message.id});
            }

            // Notify entire network that this node has joined. However, nodes joining after this node will have to request the root
            // for all nodes to know which nodes are currently available, or be part of a network that tracks all nodes in said
            // network...
            if (message.receiver === scope.name) {
                scope.post({action: Actions.JOIN, data: origins.origin(), receiver: Receivers.ALL});
            }

            // Finally dequeue all queued messages to (*)parent, since we are no longer a root node...
            queue.dequeueAll(false);

            // We also update message data, so user defined ACK callbacks need not decode themselves...
            message.data = data;
        };

        // at parent: child->parent ack received (recursively)
        on[Actions.CHILDACK] = function(message) {
            var data = scope.factory.decode(message.data, "parents", "origin", "bidirectional"), parents = data.parents.split("."),
                root = parents.shift(), child = parents.pop(), childHandler = scope.children[message.sender], indirect = child !== message.sender;

            data.bidirectional = data.bidirectional === "true";

            // Use message handler for the sender to handle (indirect) messages to the child node. We have to build
            // a tree structure to describe the sub-trees using the same message handler, to ensure that when a node
            // is closed, all sub-node structure is also removed from this node. Note that we do not handle
            // one-way child handlers here, since indirect: when trying to post to an indirect node that has a one
            // way connection to the parent, the message will in any case be a noop at the parent; this is much
            // easier than changing the behaviour of the shared child handler when nodes join or leave, including
            // shared siblings that potentially could be using the same window context...
            if (indirect) {
                var shared = childHandler.shared, parent, entry, i = parents.length;
                if (!shared) {
                    childHandler.shared = shared = {};
                }
                // Remember the child just registered. This will never override shared information for "child", since
                // the child is a descendant, not a sibling, and thus not seen before at this node...
                shared[child] = entry = {parent: root, children: [], origin: data.origin, bidirectional: data.bidirectional};

                // E.g. 'root.child2.child3.child4' -> "root" = 'root', "child" = 'child4', first "parent" = 'child3'...
                while (i--) {
                    parent = parents[i];
                    entry.parent = parent;
                    entry = shared[parent];
                    if (!entry) {
                        shared[parent] = entry = {parent: root, children: [], bidirectional: data.bidirectional}; // "parent" overridden for nested nodes above!
                    }
                    entry.children.push(child);
                }
                scope.children[child] = childHandler;

            // If bidirectional, we can now be able to post messages using the child handler, no more enqueuing...
            } else {
                // Make sure no longer posting if one way from child to this node (parent)...
                var behaviour = childHandler.behaviour();
                if (!data.bidirectional && behaviour.post) {
                    childHandler.handle(null/*same context*/, {listen: behaviour.listen});
                }
                childHandler.state = data.bidirectional ? "ready/listening" : "listening";
            }

            scope.log("Successful", indirect ? " indirect " : " ", "child", data.bidirectional ? " <" : " ", "-> parent connection: #", child, data.bidirectional ? " <" : " ", "=> #", scope.name, ": ", scope);

            // Relay routing information to parent if and only if we have acknowledgement from the entire node sub-tree,
            // i.e. when the parent path starts with this node...
            if (scope.parents && scope.name !== root) {
                scope.post(message, true); // relay, so we do not loose origin!
            }

            // Notify "child" node that this parent has joined to trigger a "join" action, but we do not post anything
            // about the ancestors. If a child node requires all nodes, use "nodes()" or a network, but this will
            // probably suit most common/simple scenarios...
            if (data.bidirectional) { // cannot post if child is not listening!
                scope.post({action: Actions.JOIN, data: origins.origin(), receiver: child});

                // Relay queued messages, if any, and only if we can actually perform bidirectional
                // communication, i.e. post, to the child...
                queue.dequeue(child);
            }

            // We also update message data, so user defined CHILDACK callbacks need not decode themselves...
            message.data = data;
        };

        // at node: received composite message where the payload is one or more messages, which we then dispatch instead, in order...
        on[Actions.COMPOSITE] = function(message) {
            var data = message.data, event = message.event, i;
            if (data) {
                if (!itr(data)) {
                    data = [data];
                }
                // Create Message objects to dispatch based on payload data...
                for (i = 0; i < data.length; i++) {
                    message = scope.factory.create(data[i], message.context, event);
                    // Ignore if we could not create a message...
                    if (message instanceof Message) {
                        scope.dispatcher.dispatch(message, "received");
                    }
                }
            }
            return noResult; // ignore ANY callback
        };

        on[Actions.ORIGIN] = function() {
            return scope.origin();
        };

        // at node, child, or parent: message from ancestor to close, or close received from parent or child, respectively
        on[Actions.CLOSE] = function(message) {
            // at this node: when this node environment is a worker, we have to close it by sending it a message, but only
            // allowed from a parent node...
            if (message.receiver === scope.name) {
                if (scope.ancestor(message.origin)) {
                    scope.close(null, message.data); // force
                    return;
                }
                scope.err("Cannot close non descendant node: ", message);
            }

            // at child: if the parent closed, we need to set up shop again to listen to connect to it, since the user may
            // have triggered a reload or what not...
            if (message.sender === scope.parent()) {
                scope.log("Parent node closed: #", message.sender);
                // No more parents - for now...
                scope.parents = null;

                // Update tree structure - already done recursively. We do not supply the "scope.name" as data here, since
                // that is already handled in the "ack" callback fired at the child node. If we are being forcefully closed,
                // no need to try and reconnect...
                if (message.data !== "force") {
                    if (scope.children) {
                        scope.post({action: Actions.ACK, receiver: Receivers.CHILDREN, correlationId: message.id});
                    }
                    // Try and re-connect then, using same target origin...
                    connector.connect();

                // If we are forcefully closed, we simply close this worker (node), closing all spawned child workers
                // implicitly in the process...
                } else if (scope.env === "worker") {
                    scope.log.verbose("Closing worker node: ", this);
                    scope.global.ctx.close(); // TODO: does this kill all spawned workers from this worker?
                }
                return;
            }

            // Relay closing information to parent node...
            if (scope.parents) {
                scope.post(message, true); // relay, so we do not loose origin!
            }

            // at parent: close relevant child handler *unless* indirect, update shared state, and purge queued messages...
            if (scope.children) {
                var child = message.origin, childHandler = scope.children[child], removed = {}, empty = true, shared, entry, parent, children, i, j;

                // Mark child as removed, so we can remove the handler and/or queued messages...
                removed[child] = 1;

                // We may not have a handler yet, e.g. if all messages have been enqueued...
                if (childHandler) {

                    // We have to delete all shared sub-tree state. None of the descendants will be direct, so we just remove
                    // them directly, and the same is true for siblings using the same postable...
                    shared = childHandler.shared;
                    if (shared) { // descendants and/or siblings with shared postable...
                        entry = shared[child];
                        if (entry) {
                            delete shared[child];

                            // Add child to list of children to remove below; will only be set if a handler is shared by
                            // descendants, not if shared by siblings using the same postable...
                            children = entry.children;
                            if (children) {
                                children.unshift(child);

                                // Remove shared descendant handlers and mark as removed...
                                for (i = 1; i < children.length; i++) { // i = 1 intentionally!
                                    child = children[i];
                                    scope.log.verbose("Removing indirect message handler: #", child);
                                    removed[child] = 1;
                                    delete scope.children[child];
                                    delete shared[child];
                                }

                                // Remove removed children from the shared state...
                                while (entry.parent !== scope.name) {
                                    parent = entry.parent;
                                    entry = shared[parent];
                                    i = entry.children.length;
                                    while (i--) { // O(n2), but we assume few nodes for general use case...
                                        j = children.length;
                                        while (j--) {
                                            if (children[j] === entry.children[i]) {
                                                entry.children.splice(i, 1);
                                                break;
                                            }
                                        }
                                    }
                                    if (!entry.children.length) {
                                        delete shared[parent];
                                    }
                                }
                            }
                        }

                        // Siblings with shared postable...
                        if (shared.siblings) {
                            // By deleting here, the next sibling in line will become the "actual receiver"
                            // of the still shared handler, unless it was the last shared child removed. The
                            // last remaining sibling will in effect always remain in the "shared.siblings"
                            // array in other to express the correct actual receiver...
                            child = message.origin;
                            shared.siblings.splice(idx(shared.siblings, child), 1);
                            removed[child] = 1;
                            if (!shared.siblings.length) {
                                delete shared.siblings;
                            }
                        }

                        // Do we have any shared state left?
                        for (child in shared) { // or "siblings"
                            if (shared.hasOwnProperty(child)) {
                                empty = false;
                                break;
                            }
                        }

                        if (empty) {
                            childHandler.shared = null;
                        } else {
                            empty = true;
                        }
                    }

                    // Do not force close unless non-shared, but always remove from children...
                    child = message.origin;
                    if (childHandler.is(child)) {
                        scope.log.verbose("Closing and removing message handler: #", child);
                        childHandler.close();
                    }
                    delete scope.children[child];

                    // Do we have any children left?
                    for (child in scope.children) {
                        if (scope.children.hasOwnProperty(child)) {
                            empty = false;
                            break;
                        }
                    }
                    if (empty) {
                        scope.children = null;
                    }

                    // Special case: when "node.context" is a worker, the child closed can be a message port
                    // used to communicate with said worker or via the worker itself. In any case, the worker
                    // is now dead - since a child (itself) has been closed - and so will the "node.context"
                    // be if that is said worker...
                    if (scope.context.type() === "worker") {
                        scope.context.close();
                        // Close connector using said worker only, but not the parent (window) connector...
                        connector.close(true); // TODO: shared workers?
                    }
                }

                // Remove queued messages with any removed child as the *origin*...
                queue.purge(removed);
            }
        };

        //
        //
        //

        // Delegate message factory to handle creation, validation, formatting, and parsing of messages...
        this.factory = new MessageFactory(scope, options.factory);

        // Default action callbacks *in order* - more can be added later on using "node.on(..)"...
        var actions = [];

        this.on = function(on, func, invocationScope, flag) {
            if (on) {
                if (str(on)) {
                    var all = on.split(/\s+/), action, i;
                    on = {};
                    for (i = 0; i < all.length; i++) {
                        if (action = all[i]) {
                            on[action] = func;
                        }
                    }
                } else {
                    flag = invocationScope;
                    invocationScope = func;
                }
                actions.push({on: on, scope: invocationScope || options.scope || scope, flag: flag});
            }
            return on;
        };

        this.off = function(on) {
            // Start from 2: we never allow internal node actions or initially configured actions to be removed...
            if (on) {
                var i = idx(actions, on, 2);
                if (i >= 2) {
                    actions.splice(i, 1);
                }
            } else {
                actions.splice(2, actions.length - 2); // all after 2
            }
            return scope;
        };

        // First: always node scope, others use configured scope, or node scope...
        scope.on(on, scope);
        scope.on(options.on);

        // Create dispatcher!
        this.dispatcher = new MessageDispatcher(scope, queue, options.validateOnSend, noResult, actions);

        //
        //
        //

        // Set up log...
        this.log = createLog(scope, options);

        // Error handler...
        this.err = function() { scope.dispatcher.err(forward(scope, arguments)); }; // raises an error...

        //
        //
        //

        // Returns the relevant (parent) context from the supplied options...
        function context(type) {
            var ctx = options[type];
            // If a MessageNode, reuse actual context, e.g. window...
            if (ctx instanceof MessageNode) {
                return ctx.context; // always "context", not "parentContext"!

            // Worker url: if the parent is a worker url, this node must be a worker...
            } else if (str(ctx)) {
                if (def("Worker")) {
                    try {
                        ctx = new Worker(ctx);

                    } catch (e) { // SecurityError
                        var msg = ": " + scope.global + " -> '" + ctx + "': ";
                        // file:// urls does not work unless security has been disabled locally...
                        if (origins.file()) {
                            msg = "Workers may not work locally with a '" + FILE + "' url and security enabled" + msg;
                        } else {
                            msg = "Cannot create worker" + msg;
                        }
                        scope.err(msg, e);
                    }

                // If workers are not supported, we default to the global context, since the node can still
                // function by itself, just not have any worker children...
                } else {
                    scope.log.err("Workers not supported, using default ", type, ": #", scope.name);
                    ctx = null;
                }

            } // no else-if here!

            return ctx;
        }

        // Set up postable context for windows, frames, and web workers, and determine the environment
        // type accordingly, i.e. "window", "frame", or "worker". The "context" is used to listen for
        // incoming CHILD actions in the node connector, and to attach relevant event handlers. For
        // a window/frame, the context is said window/frame, but for workers it is the global worker
        // scope. If a context is shared, the node using another context will register itself as a child
        // during connect...
        this.context = new Context(scope, context("context") || scope.global.ctx); // default to global

        // The "parentContext" is used to post CHILD requests when this node is a child of
        // another node. For a window, it is the window opener; for a frame, it is the window parent;
        // for a worker, it is the global worker scope (thus same as context); or it can undefined,
        // i.e. this node is thus always a root. The parent context can be supplied to allow to
        // nodes in the same window/frame/worker to be parent/child and not just siblings...
        this.parentContext = context("parentContext");

        // Deduce if not supplied...
        if (!scope.parentContext) {
            switch (scope.env) {
                case "worker":
                    scope.parentContext = scope.context.ctx; // worker.self
                    break;
                case "frame":
                    scope.parentContext = scope.global.ctx.parent;
                    break;
                case "window":
                    scope.parentContext = scope.global.ctx.opener;
                    break;
                default:
                    break; // nothing
            }
        }
        // Wrap in actual context, even if no parent context is used ("none")...
        this.parentContext = new Context(scope, scope.parentContext);

        // Add error handler to contexts if workers, so we can report errors at this node from the
        // worker...
        if (scope.context.type() === "worker") {
            scope.context.on("error", function(event) { scope.err(event.message, event); });
        } else if (scope.parentContext.type() === "worker") { // we assume same worker "context" is a worker...
            scope.parentContext.on("error", function(event) { scope.err(event.message, event); });
        }

        // Poster used to communicate with the parent node to establish the connection between this
        // (possible) child node and its (possible) parent. Even if MessageChannel is used, we still
        // need this to send the actual port to the parent and used for relaying log messages...
        this.parentPoster = scope.parentContext.set() ? new MessagePoster(scope, options.transport, origins.parent(), scope.parentContext) : null;

        this.type = function() {
            if (scope.parents) {
                return scope.children ? "node" : "leaf";
            }
            return "root";
        };

        // Bottom of parent stack is the root...
        this.root = function() { return scope.parents ? scope.parents[0] : null; };
        // Top of parent stack is the immediate parent, index zero the root...
        this.parent = function() { return scope.parents ? scope.parents[scope.parents.length - 1] : null; };

        this.ancestor = function() {
            if (scope.parents) {
                var i = scope.parents.length, j;
                while (i--) {
                    for (j = 0; j < arguments.length; j++) {
                        if (scope.parents[i] === arguments[j]) {
                            return true;
                        }
                    }
                }
            }
            return false;
        };
        this.descendant = function() {
            if (scope.children) {
                var i;
                for (i = 0; i < arguments.length; i++) {
                    if (scope.children[arguments[i]]) {
                        return true;
                    }
                }
            }
            return false;
        };

        this.nodes = function() {
            var nodes = [], child;
            if (scope.children) {
                for (child in scope.children) {
                    if (scope.children.hasOwnProperty(child)) {
                        nodes.push(child);
                    }
                }
            }
            return nodes;
        };

        this.newContext = function(context) {
            return new Context(scope, context instanceof Context ? context.ctx : context);
        };

        this.newProxy = function(receiver, target, matcher, options) {
            if (arguments.length > 2) {
                return new MessageNodeProxy(scope, receiver, target, matcher, options);
            }
            // For MessageNode itself as the target...
            return new MessageNodeProxy(scope, receiver, scope, function(func) {
                return idx(["type", "root", "parent", "ancestor", "descendant", "nodes", "origin", "dump"], func) === -1 ? null : undefined; // null: not proxied, undefined: proxied, but no extra arguments for proxied function
            }, options || {tag: scope.tag, prefixMessage: true});
        };

        this.newMessage = function(message, processor) { // public!
            var messages = createMessages(message, processor);
            return messages.length === 1 ? messages[0] : messages;
        };

        function createMessage(message, processor) { // always returns a *new* single message!
            var relay = typeof processor === "boolean" && processor;

            if (str(message)) {
                message = {action: message};
            }

            // Allow origin and tag from passed in message to support relaying of messages...
            var origin = (relay && message && message.origin) || scope.name, tag = (relay && message && message.tag) || scope.tag;

            // May return a new "empty" message if "message" is undefined...
            message = scope.factory.create(message); // no context yet, not until we actually post...

            if (!message) { // null or undefined
                throw new Error("No message to post");
            }

            // Specify this node...
            message.sender = scope.name;

            // Origin/tag: supplied one, if any, on relay, otherwise this node...
            message.origin = origin;
            message.tag = tag;

            // Post processing of "message" after creation? This allows "plugins" to alter message to their needs, for example
            // a network using a specific tag...
            if (fn(processor)) {
                processor("after", message, scope);
            }

            // Make sure protocol actions are not enqueued except composite (and those from networks, since
            // it handles queuing explicitly)...
            if (Actions.protocol(message) && message.action !== Actions.COMPOSITE) {
                Selectors.add(message, Selectors.NO_QUEUE);

            // Enqueue message for now, at this node? Can be dequeued using "node.enqueue(false)"...
            } else if (enqueue) {
                Selectors.add(message, Selectors.QUEUE);
            }

            // Add default selectors, if any...
            if (defaults.selectors) {
                Selectors.add(message, defaults.selectors);
            }

            return message;
        }

        // Create messages, one for each "message.receiver", and though each message is logically the same message,
        // it will be assigned a unique id, so the sender can trace which recipients responded...
        function createMessages(message, processor, defReceiver) {
            var receiver, messages = [], msg, i;
            // Pre processing of *original* "message" before a new message(s) is/are created based on it? This allows
            // "plugins" to alter message to their needs, for example adding receivers to the message. It also allows
            // a user to specify how a message should be created...
            if (fn(processor)) {
                if (msg = processor("before", message, scope)) {
                    message = msg;
                }
            }

            // Find array of receivers: a message will be created for each one...
            var receivers = (message && message.receiver) || defReceiver;
            if (!itr(receivers)) {
                receivers = [receivers];
            }

            for (i = 0; i < receivers.length; i++) {
                if (receiver = receivers[i]) {
                    // Create *new* message...
                    msg = createMessage(message, processor); // this calls "processor("after", ..) for spawned message
                    msg.id = scope.factory.id();
                    msg.receiver = receiver;
                    messages.push(msg);
                }
            }
            return messages;
        }

        function postSingle(message, processor) {
            var msg, steps, entry = {}, i;
            // Single logical message, but different physical ones will be sent to each receiver...
            message = createMessages(message, processor, defaults.receiver);
            for (i = 0; i < message.length; i++) {
                msg = message[i];
                steps = scope.dispatcher.dispatch(msg, "post");
                // Index message by both id and receiver for easy reference...
                entry[msg.id] = entry[msg.receiver] = {message: msg, steps: steps};
            }
            return entry;
        }

        // Undefined behaviour if different/distinct receivers are used per message, "union" assumed. This
        // also allows just the *first* of the messages to specify the receiver(s)...
        function postComposite(messages, processor) {
            if (messages.length === 1) {
                return postSingle(messages[0], processor);
            }
            var data = [], receivers = [], unique = {}, message, msg, receiver, i, j, defReceiver = defaults.receiver;
            for (i = 0; i < messages.length; i++) {
                // First message will default to actual default receivers, but additional ones must default to the
                // receivers for the first message, or composite messages will also be sent to the default receiver...
                message = createMessages(messages[i], processor, defReceiver);
                if (!i) {
                    defReceiver = [];
                }
                for (j = 0; j < message.length; j++) {
                    msg = message[j];
                    data.push(msg);
                    unique[msg.receiver] = 1;
                    if (!i) {
                        defReceiver.push(msg.receiver);
                    }
                }
            }
            for (receiver in unique) {
                if (unique.hasOwnProperty(receiver)) {
                    receivers.push(receiver);
                }
            }
            return postSingle({action: Actions.COMPOSITE, data: data, receiver: receivers}); // relay already handled
        }

        this.enqueue = function(onOff) {
            if (typeof onOff !== "undefined" && onOff !== enqueue) {
                if (!(enqueue = onOff)) {
                    queue.dequeueAll(true); // dequeue all messages enqueued with a QUEUE selector...
                }
            }
            return enqueue;
        };

        this.post = function(message, processor, interval, ignoreInLog) { // negative interval: one-time abs delay, positive: periodic interval, starting "now"
            if (scope.type() === "closed") {
                if (!options.ignorePostAfterClosed) {
                    scope.err("Message node closed: #", scope.name, ": ", scope); // will raise an Error...
                }
                return null;

            } else if (typeof processor === "number") {
                ignoreInLog = interval;
                interval = processor;
                processor = null;
            }

            var entry, timer = false, delay = false, i;
            if (typeof interval === "number" && interval !== 0) {
                timer = true;
                // A negative interval means a one-time delay before posting...
                if (interval < 0) {
                    interval = -interval;
                    delay = true;
                }
            }

            if (!delay) {
                entry = itr(message) ? postComposite(message, processor) : postSingle(message, processor);
            }

            if (timer) {
                if (typeof ignoreInLog === "undefined") {
                    ignoreInLog = true;
                }
                // Since this message will be posted repeatedly, we might want to ignore it in the log...
                if (ignoreInLog) {
                    i = idx(options.log.ignore, message.action);
                    if (i === -1) {
                        options.log.ignore.push(message.action);
                    }
                }

                function clearTimer() {
                    if (timer) {
                        scope.global.ctx.clearInterval(timer);
                        entry.timer = timer = null;
                    }
                    if (ignoreInLog) {
                        var i = idx(options.log.ignore, message.action);
                        if (i !== -1) {
                            options.log.ignore.splice(i, 1);
                        }
                    }
                }
                // Context can simply null "entry.timer" to stop the timer...
                entry.timer = timer = scope.global.ctx.setInterval(function() {
                    if (entry.timer && scope.type() !== "closed") {
                        entry.last = scope.post(message, processor);
                        if (delay) {
                            clearTimer();
                        }
                    } else {
                        clearTimer();
                    }
                }, interval);
            }
            return entry;
        };

        this.reply = function(received) { // reply(received, data, action, selectors) OR reply(received, [{action: .., data: ..}, {..}, .., {..}])
            var message;
            if (itr(arguments[1])) {
                message = arguments[1]; // composite
            } else {
                message = {data: arguments[1], action: arguments[2] || received.action, selectors: arguments[3]};
            }
            // Add processor to attach receiver and correlation id to each message to reply with...
            return scope.post(message, function (type, message) {
                if (type === "before") {
                    message.receiver = received.origin;
                    message.correlationId = received.id;
                }
            });
        };

        this.bind = function(message, processor, interval) {
            return function() {
                return scope.post(message, processor, interval);
            };
        };

        this.close = function(descendant, type) {
            // Already closed?
            if (scope.type() === "closed") {
                return scope;
            }

            // Close a descendant of ours? This will only succeed if the child in question is
            // actually a descendant, and is needed to close (at least) worker children...
            if (str(descendant) || itr(descendant)) { // also called on "unload" with Event as argument
                return scope.post({action: Actions.CLOSE, data: "force", receiver: descendant});
            }

            // Removed exported node if exported and clear if from global map of nodes...
            NODES.remove(scope.name);

            // Remove event handlers...
            scope.global.off();
            scope.context.off();
            scope.parentContext.off();

            // Close connector...
            if (connector) {
                connector.close();
            }

            // Array of "leave" actions, one for each child of this node + this node itself...
            var messages = [], parentHandler = scope.parentHandler.ready();

            // Send to children that this node has been closed and then close handlers - we cannot start
            // closing handlers until all messages have been sent, since handlers are unordered. Since the
            // closing will close handlers, we have to notify our descendants explicitly first with a LEAVE
            // action, or they will never get it, since an ALL message will always bubble up to the root
            // before being actually dispatched, at which time this node is closed and no messages can
            // pass through it to its children...
            if (scope.children) {
                scope.post({action: Actions.LEAVE, data: type || "self", receiver: Receivers.CHILDREN, selectors: Selectors.ALL});
                scope.post({action: Actions.CLOSE, data: type || "self", receiver: Receivers.CHILDREN});

                var child, childHandler;
                for (child in scope.children) {
                    if (scope.children.hasOwnProperty(child)) {
                        childHandler = scope.children[child];
                        // If we have any children, at least one will be a direct one, and closing it will close
                        // the shared ones as well...
                        if (childHandler.is(child)) {
                            childHandler.close();
                        }
                        // Ok to push here, since any child below this node will be affected by this node being closed. If no
                        // ready parent handler is available, we cannot post anything...
                        if (parentHandler) {
                            messages.push({action: Actions.LEAVE, origin: child, data: type || "self", receiver: Receivers.ALL});
                        }
                    }
                }
                scope.children = null;
            }

            // Send to parent that this node has been closed. The parent handler will ever only be ready if
            // we have parents, i.e. if it has been acknowledged...
            if (parentHandler) {
                type = type === "force" ? "self" : type || "self";
                // Post "leave" message for this node and for all possible (closed) children *before* we post "close" message to parent, or
                // this message will be ignored...
                messages.unshift({action: Actions.LEAVE, data: type, receiver: Receivers.ALL});
                scope.post(messages, true); // relay as for each child

                // Post "close" message...
                scope.post({action: Actions.CLOSE, data: type, receiver: Receivers.PARENT}); // can never force an ancestor...
            }

            // Always close, even if not ready...
            scope.parentHandler.close();
            scope.parents = null; // null here for better logging in the above statement!

            if (scope.parentPoster) { // TODO: we did not use to close the parent poster here? Oversight, or intentional?
                scope.parentPoster.close();
            }

            scope.type = function() { return "closed"; };

            // Purge queue...
            queue.purgeAll();

            return scope;
        };

        this.dump = function() {
            var oldLog, child, childHandler, i, qualified, allActions = (function() {
                var count = {}, name, names = [], i;
                function action(target, path) {
                    var t, p;
                    if (target) {
                        for (name in target) {
                            if (target.hasOwnProperty(name)) {
                                t = target[name]; p = path ? path + "." + name : name;
                                if (obj(t)) {
                                    action(t, p);
                                } else {
                                    count[p] = (count[p] || 0) + 1;
                                }
                            }
                        }
                    }
                }
                // i = 1: do not include internal callbacks, only user defined ones...
                for (i = 1; i < actions.length; i++) {
                    action(actions[i].on);
                }
                for (name in count) {
                    if (count.hasOwnProperty(name)) {
                        names.push(name);
                    }
                }
                if (fn(names.sort)) {
                    names.sort();
                }
                return {names: names, count: count};
            })();

            if (!scope.log.will("log")) {
                oldLog = scope.log.config({log: true});
            }

            scope.log("Message node:       ", scope);

            for (i = 0; i < allActions.names.length; i++) {
                scope.log("Action:             ", Receivers.name(scope.name), ".on.", allActions.names[i], " (", allActions.count[allActions.names[i]], ")");
            }

            scope.log("Origins:            ", origins);
            scope.log("Node global:        ", scope.global);
            scope.log("Node context:       ", scope.context);

            scope.log("Parent context:     ", scope.parentContext);
            scope.log("Parent poster:      ", scope.parentPoster  || "none");
            scope.log("Parent handler:     ", scope.parentHandler);

            scope.log("Node connector:     ", connector);
            scope.log("Message queue:      ", queue);
            scope.log("Message factory:    ", scope.factory);
            scope.log("Message dispatcher: ", scope.dispatcher);
            scope.log("Log:                ", scope.log.toString());

            if (scope.children) {
                for (child in scope.children) {
                    if (scope.children.hasOwnProperty(child)) {
                        childHandler = scope.children[child];
                        qualified = childHandler.qualified(child);
                        if (qualified.origin !== origins.origin()) {
                            scope.log("Child handler (xd): ", qualified.name, " at '", qualified.origin, "' -> ", childHandler);
                        } else {
                            scope.log("Child handler:      ", qualified.name, " -> ", childHandler);
                        }
                    }
                }
            }

            scope.log("Have a nice day! :)");
            if (oldLog) {
                scope.log = oldLog;
            }
            return scope; // neat when called from the console
        };

        this.toString = function() {
            var s = "MessageNode[name: #" + scope.name + "; tag: " + scope.tag + "; type: " + scope.type() + "; env: " + scope.env, child, first = true;

            if (origins.origin()) {
                s += "; origin: '" + origins.origin() + "'";
            }

            s += "; default-receiver: " + Receivers.name(defaults.receiver);

            if (scope.parents) {
                s += "; parent: #" + join(scope.parents, "(*).#");
            }
            if (scope.children) {
                s += "; children: [";
                for (child in scope.children) {
                    if (scope.children.hasOwnProperty(child)) {
                        if (first) {
                            first = false;
                        } else {
                            s += ", ";
                        }
                        s += scope.children[child].qualified(child).name;
                    }
                }
                s += "]";
            }
            if (queue.size()) {
                s += "; queue: " + queue;
            }
            return s + "; channels: " + options.channels + "]";
        };

        // Create handler to post messages to the parent node, but note that we do not have the actual
        // postable (port) to use yet if channels are used, not until we have connected. The
        // MessageNodeConnector will set/update with the proper postable upon connect attempts.
        // If "options.type" is "root", the handler will never be connected...
        this.parentHandler = new MessageHandler(scope, options, "->parent", origins, null, {post: true}, scope.parent);
        this.parentHandler.targetOrigin(origins.parent());

        // Create connector to establish parent/child connections, if any...
        connector = new MessageNodeConnector(scope, options, origins);

        // Make sure this node listen for "unload" events (has no effect within workers)...
        if (scope.env !== "worker") {
            scope.global.on("unload", function () { scope.close(null, "global"); });
        }

        NODES.add(scope.name, scope, options.eksport);

        // Unless the node type is explicitly set to "root" here, try and connect to the parent node.
        // Even if "connect" is not called, the connector will still listen for incoming requests
        // unless the type is set to "leaf" at this point...
        if (options.type !== "root") { // respect *initial* type!
            connector.connect();
        }
    }

    MessageNode.options = function(options) {
        if (!options) {
            options = {};
        // If "options" is a string, assume a node name for convenience...
        } else if (str(options)) {
            options = {name: options};
        }
        // Update options with "tag" and "name", since options may be used by other types as well..
        if (!options.tag) {
            options.tag = "@zmags";
        }
        if (!options.name) {
            options.name = self.name || "node" + now();
        }
        return options;
    };

    // Factory method that will *not* re-create a given node if it already exist for the global scope...
    MessageNode.create = function(options) {
        // Create default options, if none supplied...
        options = MessageNode.options(options);
        var entry = NODES.get(options.name);
        return entry ? entry.object : new MessageNode(options); // constructor creates an entry in NODES
    };


    //
    // PROXY
    //


    function MessageNodeProxy(node, receiver, target, matcher, options) {
        var scope = this, functions = {}, actions = {}, func, args;

        if (obj(matcher)) {
            options = matcher;
            matcher = null;
        }

        this.tag = options.tag || node.tag + "_proxy_" + now();

        var noResult = options.noResult || node.options("noResult") || MessageNode.NO_RESULT;

        // Incoming: Expose functions that can be proxied on *this* node (actually "node"), so a remote node
        // can act as a proxy for them. Each function will be supplied the message data as arguments, and
        // the result will be returned as message data...
        function proxiedFunction(action) {
            functions[action] = function (message) {
                return target[action].apply(target, message.data);
            }
        }
        for (func in target) {
            if (target.hasOwnProperty(func) && fn(func)) {
                if (!matcher || matcher(func, target) !== null) {
                    proxiedFunction(func);
                }
            }
        }
        node.on(functions, target);

        // Outgoing: prime this proxy with similar named functions, to post messages to the proxied node(s) and
        // expect a corresponding result...
        function closure(action, args) {
            // Post request for proxied function...
            scope[action] = function() {
                return node.post({tag: scope.tag, action: action, data: forward(scope, arguments, args), receiver: receiver, selectors: Selectors.REPLY + Selectors.NO_QUEUE});
            };
            // Receive result...
            actions[action] = function(message) {
                var args = message.data === noResult ? undefined : message.data;
                if (!itr(args)) {
                    args = [args];
                }
                if (options.prefixMessage)  { args.unshift(message); }
                if (options.postfixMessage) { args.push(message);    }

                target[action].apply(target, args);
            };
        }

        for (func in target) {
            if (target.hasOwnProperty(func) && fn(func)) {
                if (!matcher || (args = matcher(func, target)) !== null) {
                    closure(func, args);
                }
            }
        }
        node.on(actions, scope, function(message) { return message.tag === scope.tag; });

        node.factory.handle(scope, true);

        this.close = function() {
            node.factory.handle(scope, false);
            node.off(actions);
            node.off(functions);
        };

        this.toString = function() {
            var s = "MessageNodeProxy[target-node: " + Receivers.name(receiver) + "; target: " + target;
            if (scope.tag !== node.tag) {
                s += "; tag: " + scope.tag;
            }
            return s + "]";
        };
    }


    //
    // LOG
    //


    // Factory method that creates a log to use...
    function createLog(node, options) {

        // Notational short-cuts...
        if (options.log) {
            if (str(options.log)) {
                // err added by default below...
                if (options.log === "log") {
                    options.log = {log: true};
                } else if (options.log === "err") {
                    options.log = {};
                } else if (options.log === "verbose") {
                    options.log = {log: true, verbose: true};
                }
            } else if (!obj(options.log)) {
                options.log = {log: options.log, err: options.log};
            }
        } else if (!obj(options.err)) {
            options.log = {err: options.err}; // enable "err" by default...
            delete options.err;
        }
        // Enable "err" by default if not configured...
        if (typeof options.log.err === "undefined") {
            options.log.err = true;
        }

        // Message actions to ignore during logging since known to flood the log, e.g. pings...
        if (str(options.log.ignore)) {
            options.log.ignore = [options.log.ignore];
        } else if (typeof options.log.ignore === "undefined") {
            options.log.ignore = [];
        }

        var legacy = node.global.legacy(), tag = "[" + (options.tag || node.tag) + ":" + (options.log.name || options.name || node.name) + "]";

        // Required since for example no Event type in Worker implementation...
        function evt(o) {
            try {
                return o && (is(o, "Event") || typeof o.srcElement !== "undefined");
            } catch (e) { // SecurityError
                return false;
            }
        }

        // Required since (some version of ?) Firefox apparently throws a "wrapped native prototype object" instead of an Error
        // when cross domain communication fails...
        function error(o) {
            try {
                return o && (is(o, "Error") || (str(o.name) && idx(o.name, "Error") !== -1 && typeof o.message !== "undefined"));
            } catch (e) { // SecurityError
                return false;
            }
        }

        function format(args) {
            var msg = {prefix: tag + " <" + ++sequence + "> -", text: "", message: null, error: null, event: null}, i, j, arg;

            // Explode if arguments contains a nested array as the single argument...
            if (itr(args[0]) && args.length === 1) {
                args = args[0];
            }

            for (i = 0; i < args.length; i++) {
                arg = args[i];
                if (typeof arg !== "undefined") {
                    if (arg instanceof Message) {
                        msg.message = arg;

                        // Configure actions to ignore during logging to avoid flooding the log...
                        for (j = 0; j < options.log.ignore.length; j++) {
                            if (options.log.ignore[j] === arg.action) {
                                return {}; // nothing to log!
                            }
                        }

                    } else if (error(arg)) {
                        msg.error = arg;
                        arg = def("Error") ? Error.prototype.toString.call(arg) : arg.toString();

                    } else if (evt(arg)) {
                        msg.event = arg;
                        continue; // do not log this as part of the message...
                    }
                    msg.text += Context.val(arg, null, "[???]");
                }
            }

            // To not add prefix to an already prefixed messages, i.e. a relayed message from a worker or console-less environment...
            if (idx(msg.text, "[" + node.tag + ":") === 0) {
                msg.prefix = null;
                sequence--;
            }
            return msg;
        }

        // Used configured out (out.info(..) and out.error(..)) or standard window console...
        var konsole = options.log.out || node.global.ctx.console; // may be undefined!

        // Standard out function logging to the console. The test for prefix is to allow relayed log messages to be
        // handled nicely. Cannot use "apply" and "call" on console function, e.g. "info", because of IE legacy issues...
        function out(type, prefix, msg, relayedOnly) {
            if (!prefix) {
               konsole[type](msg);

            // Prefix means local node...
            } else if (!relayedOnly) {
                if (legacy) { // FIXME: also on Ipad!
                    konsole[type](prefix + " " + msg); // has to use + since , not supported well in legacy browsers when called like this...
                } else {
                    konsole[type](prefix, msg); // to support logging objects...
                }
            }
        }

        // Relay log message to parent node...
        function relay(type, prefix, msg) {
            // Include prefix, since when logged at some parent node, said node will otherwise include its own prefix...
            if (prefix) {
                msg = prefix + " " + msg;
            }
            // Relay directly using bogus id, i.e. "log" or "err"!...
            if (node.parentPoster) { // TODO: this will fail if closed, no?
                node.parentPoster.post(node.newMessage({id: type, action: type, data: msg, receiver: Receivers.PARENT}));
            }
        }

        function configure(option, type) {
            var value = options.log[option]; // option: "log" or "err"
            // No logging...
            if (!value || value === "off") {
                return null;

            // Relay to parent node if so configured, but always for workers (unless off) since they have no console.
            // If explicitly configured as a root, we treat relay as "on"...
            } else if (options.type !== "root" && (value === "relay" || node.env === "worker")) {
                return function doRelay(prefix, msg) { relay(option, prefix, msg); }; // "log"/"err"

            // Output function as-is...
            } else if (fn(value)) {
                return value;

            // Probably some IE in non-debugging mode, i.e. console not even declared...
            } else if (typeof konsole === "undefined") {
                return null;
            }
            // "value" is some truthy value here or "relayOnly"...
            return function doOut(prefix, msg) { out(type, prefix, msg, value === "relayOnly"); }; // "info"/"error"
        }

        // Configure how log and error messages are logged, individually. This allows for example error messages for
        // a worker context to be logged, while normal log messages need not be...
        var log = configure("log", "info"), err = configure("err", "error"), verbose = options.log.verbose, sequence = 0;

        function logger() {
            var msg;
            if (log) {
                msg = format.call(format, arguments);
                if (msg.text) {
                    log(msg.prefix, msg.text, log); // String
                }
                if (verbose) {
                    if (msg.message) {
                        log(msg.prefix, msg.message, log);
                    }
                    if (msg.event) {
                        log(msg.prefix, msg.event, log); // Event/Object
                    }
                }
            }
            return msg;
        }

        logger.will = function(type) {
            switch (type) {
                case "log": return log !== null;
                case "err": return err !== null;
                case "verbose": return typeof verbose !== "undefined" && verbose;
                return false;
            }
        };

        logger.verbose = function() {
            var msg;
            if (verbose) {
                msg = logger.apply(logger, forward(node, arguments));
            }
            return msg;
        };

        logger.err = function() {
            var msg;
            if (err) {
                msg = format.call(format, arguments);
                var error = msg.error ? msg.error : new Error(msg.text), stack;
                // Only log text if we have a specific error as well, since the Error created above will log
                // the text anyway...
                if (msg.text && msg.error) {
                    err(msg.prefix, msg.text, err); // String
                }
                // Stack not always available and will not always contain the actual error message...
                stack = error.stack;
                if (stack) {
                    stack = stack.toString();
                    if (idx(stack, error.message) === -1) {
                        err(msg.prefix, error + " " + stack, err); // Error+stack
                    } else {
                        err(msg.prefix, stack, err); // stack
                    }
                } else {
                    err(msg.prefix, error, err); // Error/Object
                }
                if (msg.message) {
                    err(msg.prefix, msg.message, err); // Message
                }
                if (msg.event) {
                    err(msg.prefix, msg.event, log); // Event/Object
                }
            }
            return msg;
        };

        logger.format = format; // e.g. to format messages to be sent as data

        // Re-configure logger at runtime...
        logger.config = function(opts) { var old = node.log; node.log = createLog(node, opts); return old; };

        logger.toString = function() {
            return "Log[tag: " + tag + "; log: " + (options.log.log || false) + "; err: " + (options.log.err || false) + "; verbose: " + (verbose || false) + "]";
        };
        return logger;
    }


    //
    // EXPOSE
    //

    MessageNode.NO_RESULT = "*no_result*";

    // Since MessageNode can run in various different environments, we also expose the utility functions needed to
    // handle such varieties, so "plugins" can make use of them as well...
    MessageNode.Fn = { def: def, is: is, obj: obj, fn: fn, str: str, join: join, idx: idx, itr: itr, forward: forward, copy: copy };
    // Expose Message type publicly, also relevant for AMD support...
    MessageNode.Message = Message;
    // Expose Origins publictly to make it somewhat easier to work with normalised origins...
    MessageNode.Origins = Origins;

    // Expose Actions, Receivers, and Selectors publicly...
    Message.Actions   = copy(Actions); // copy, so "protocol" still works if more actions are added by "plugins"!
    Message.Receivers = Receivers;
    Message.Selectors = Selectors;


    (function() {

        // MessageNode.Message holds Message type, Message holds Receivers and Selectors types...
        function amd(scope) {
            var dfine = scope ? scope.define : (typeof define !== "undefined" && define); // latter when declared as "var define"...
            if (fn(dfine) && dfine.amd) {
                dfine("message_node", [], function() { return MessageNode; });
                return false;
            }
            return true;
        }

        if (typeof exports == 'object') {
            module.exports = MessageNode;
        } else if (typeof universe !== "undefined") {
            var ctx = path(self, universe);
            if (amd(ctx)) { // foo.bar.define
                ctx.MessageNode = MessageNode; // foo.bar.MessageNode
            }

        } else if (amd()) { // var define, likely ours, i.e. bundled/optimized
            amd(self); // self.define
            // self.MessageNode - we expose this here as well, since it is likely it is not our require at self.require!
            if (typeof self.MessageNode === "undefined") {
                self.MessageNode = MessageNode;
            }
        }

    })();


})(self, self.____message_node_scope);



// WEBPACK FOOTER //
// ./src/editor/services/messageNode/MessageNode.js